(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["catalogo-fustelle-2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('m3-fustelle-catalog-v2')) {
  customElements.define('m3-fustelle-catalog-v2', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
    normalize(value) { return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('it').replace(/\s+/g, ' ').trim(); }
    initialize() {
      if (this.controller || !this.querySelector('[data-controls]')) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.search = this.querySelector('[data-search]');
      this.selected = { category:'', sector:'' };
      this.dimensions = {};
      this.cards = [...this.querySelectorAll('[data-catalog-card]')].map(element => ({
        element,
        category: this.normalize(element.dataset.category),
        sector: String(element.dataset.sector || '').split(',').map(s => this.normalize(s)).filter(Boolean),
        text: this.normalize(element.dataset.searchText)
      }));
      this.groups = [...this.querySelectorAll('[data-filter-group]')];
      this.groups.forEach(group => {
        group.querySelectorAll('[data-generated]').forEach(el => el.remove());
        const key = group.dataset.filterGroup;
        const labels = new Map();
        this.cards.forEach(card => {
          const values = key === 'sector' ? String(card.element.dataset.sector || '').split(',') : [card.element.dataset.category || ''];
          values.forEach(label => { const value = this.normalize(label); if (value && !labels.has(value)) labels.set(value, label.trim()); });
        });
        labels.forEach((label, value) => {
          const button = document.createElement('button');
          button.type = 'button'; button.dataset.value = value; button.dataset.generated = '';
          button.setAttribute('aria-pressed', 'false');
          const name = document.createElement('span'); name.textContent = label;
          if (this.cards.some(card => card.element.dataset.new === 'true' && (key === 'sector' ? card.sector.includes(value) : card.category === value))) {
            const dot = document.createElement('span'); dot.className = 'm3-new-dot'; dot.setAttribute('role','img'); dot.setAttribute('aria-label',this.dataset.newLabel); name.append(dot);
          }
          button.append(name);
          const count = document.createElement('span'); count.className = 'm3-filter-count'; count.setAttribute('aria-hidden','true');
          count.textContent = String(this.cards.filter(card => key === 'sector' ? card.sector.includes(value) : card.category === value).length);
          button.append(count); group.append(button);
        });
        if (key === 'sector') group.closest('[data-sector-section]').hidden = labels.size === 0;
        group.addEventListener('click', event => {
          const button = event.target.closest('button[data-value]');
          if (!button || !group.contains(button)) return;
          this.selected[key] = button.dataset.value; this.filter();
        }, {signal});
      });
      this.sidebar = this.querySelector('[data-sidebar]');
      this.toggle = this.querySelector('[data-toggle]');
      this.media = window.matchMedia('(min-width: 1024px)');
      this.sidebarPreference = null;
      if (this.toggle) {
        this.toggle.addEventListener('click', () => {
          this.sidebarPreference = this.sidebar.hidden;
          this.setSidebar(this.sidebarPreference);
        }, {signal});
        this.media.addEventListener('change', () => this.setSidebar(this.sidebarPreference ?? (this.media.matches && this.dataset.initialSidebar === 'true')), {signal});
        this.setSidebar(this.media.matches && this.dataset.initialSidebar === 'true');
      }
      this.search.addEventListener('input', () => this.filter(), {signal});
      this.querySelector('[data-dimensions]')?.addEventListener('submit', event => {
        event.preventDefault();
        this.dimensions = {};
        this.querySelectorAll('[data-dimension]').forEach(input => { if (input.value && input.validity.valid) this.dimensions[input.dataset.dimension] = input.valueAsNumber; });
        this.filter();
      }, {signal});
      this.querySelector('[data-reset]').addEventListener('click', () => { this.resetFilters(); this.search.focus({preventScroll:true}); }, {signal});
      this.querySelector('[data-all]')?.addEventListener('click', () => this.resetFilters(), {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.sidebar && !this.sidebar.hidden && this.sidebar.contains(event.target)) {
          this.sidebarPreference = false; this.setSidebar(false); this.toggle.focus();
        }
      }, {signal});
      this.addEventListener('shopify:block:select', () => this.resetFilters(), {signal});
      this.querySelector('[data-controls]').hidden = false;
      this.querySelector('[data-results-bar]').hidden = false;
      this.filter();
    }
    setSidebar(open) {
      if (!this.sidebar) return;
      this.sidebar.hidden = !open;
      this.querySelector('[data-layout]').classList.toggle('has-sidebar', open);
      this.toggle.setAttribute('aria-expanded', String(open));
      this.toggle.querySelector('[data-toggle-label]').textContent = open ? this.toggle.dataset.hideLabel : this.toggle.dataset.showLabel;
    }
    resetFilters() {
      this.search.value = ''; this.selected = {category:'', sector:''}; this.dimensions = {};
      this.querySelector('[data-dimensions]')?.reset(); this.filter();
    }
    filter() {
      const words = this.normalize(this.search.value).split(' ').filter(Boolean);
      let count = 0;
      this.cards.forEach(card => {
        const fits = Object.entries(this.dimensions).every(([axis, value]) => {
          const min = Number(card.element.dataset[axis + 'Min']);
          const max = Number(card.element.dataset[axis + 'Max']);
          return max > 0 && min >= 0 && min <= max && value >= min && value <= max;
        });
        const visible = (!this.selected.category || card.category === this.selected.category) && (!this.selected.sector || card.sector.includes(this.selected.sector)) && words.every(word => card.text.includes(word)) && fits;
        card.element.hidden = !visible; if (visible) count++;
      });
      this.groups.forEach(group => group.querySelectorAll('button[data-value]').forEach(button => {
        const selected = button.dataset.value === this.selected[group.dataset.filterGroup];
        button.setAttribute('aria-pressed', String(selected));
        button.hidden = button.dataset.value === '' && selected;
      }));
      this.querySelector('[data-count]').textContent = String(count);
      this.querySelector('[data-empty]').hidden = count !== 0;
      this.querySelector('[data-reset]').hidden = !this.search.value && !this.selected.category && !this.selected.sector && Object.keys(this.dimensions).length === 0;
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["client-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('packly-client-rotator')) {
    customElements.define('packly-client-rotator', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('.client-grid');
        this.items = Array.from(this.querySelectorAll('.client-logo'));
        this.button = this.querySelector('.client-pause');
        if (!this.grid || !this.items.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.page = 0;
        this.version = 0;
        this.paused = false;
        this.hovered = false;
        this.editing = false;
        this.visible = true;
        this.animations = [];
        this.button.addEventListener('click', () => {
          this.paused = !this.paused;
          this.button.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
          this.button.setAttribute('aria-pressed', String(this.paused));
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', () => {
          this.hovered = this.dataset.hoverPause === 'true';
          this.schedule();
        }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.items.findIndex(item => item.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editing = true;
          this.cancel();
          this.page = Math.floor(index / this.count);
          this.render();
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editing = false; this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => {
          this.cancel();
          this.render();
          this.schedule();
        }, options);
        this.reduced.addEventListener('change', () => this.layout(true), options);
        this.resizeObserver = new ResizeObserver(() => this.layout());
        this.resizeObserver.observe(this);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        });
        this.intersectionObserver.observe(this);
        this.setAttribute('data-ready', '');
        this.layout(true);
      }
      layout(force = false) {
        const count = parseInt(getComputedStyle(this).getPropertyValue('--client-count'), 10) || 8;
        if (!force && count === this.count) return;
        this.cancel();
        this.count = count;
        this.pages = Math.ceil(this.items.length / count);
        this.page = Math.min(this.page, this.pages - 1);
        this.button.hidden = this.pages <= 1 || this.reduced.matches;
        this.render();
        this.schedule();
      }
      render() {
        this.items.forEach((item, index) => {
          item.hidden = !this.reduced.matches && Math.floor(index / this.count) !== this.page;
        });
      }
      canRun() {
        return this.isConnected && this.pages > 1 && !this.reduced.matches && !this.paused && !this.hovered && !this.editing && this.visible && !document.hidden;
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.canRun() || this.busy) return;
        const interval = Math.max(3000, Number(this.dataset.interval) || 6000);
        this.timer = setTimeout(() => this.advance(), interval - 1000);
      }
      async animateVisible(frames, duration, easing) {
        this.animations = this.items.filter(item => !item.hidden).map(item => item.animate(frames, { duration, easing, fill: 'both' }));
        await Promise.all(this.animations.map(animation => animation.finished.catch(() => {})));
      }
      async advance() {
        if (!this.canRun()) return;
        this.busy = true;
        const version = ++this.version;
        await this.animateVisible([
          { opacity: 1, filter: 'blur(0px)', transform: 'translateY(0)' },
          { opacity: 0, filter: 'blur(8px)', transform: 'translateY(-20%)' }
        ], 300, 'ease-in');
        if (version !== this.version) return;
        this.animations.forEach(animation => animation.cancel());
        this.page = (this.page + 1) % this.pages;
        this.render();
        await this.animateVisible([
          { opacity: 0, filter: 'blur(8px)', transform: 'translateY(20%)' },
          { opacity: 1, filter: 'blur(0px)', transform: 'translateY(0)' }
        ], 700, 'cubic-bezier(.16, 1, .3, 1)');
        if (version !== this.version) return;
        this.animations.forEach(animation => animation.cancel());
        this.animations = [];
        this.busy = false;
        this.schedule();
      }
      cancel() {
        clearTimeout(this.timer);
        this.version += 1;
        this.animations.forEach(animation => animation.cancel());
        this.animations = [];
        this.busy = false;
      }
      disconnectedCallback() {
        if (!this.controller) return;
        this.cancel();
        this.controller.abort();
        this.resizeObserver.disconnect();
        this.intersectionObserver.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["em-assistenza-mappa"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('em-support')) {
  customElements.define('em-support', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      this.addEventListener('click', async (event) => {
        const button = event.target.closest('[data-em-chat]');
        if (!button || this.busy) return;
        this.busy = true;
        const notice = this.querySelector('[data-em-notice]');
        notice.hidden = true;
        button.setAttribute('aria-busy', 'true');
        try {
          let opened = false;
          for (let attempt = 0; attempt < 20 && this.isConnected; attempt++) {
            if (this.openInbox()) { opened = true; break; }
            await new Promise(resolve => setTimeout(resolve, 250));
          }
          if (!opened && this.isConnected) notice.hidden = false;
        } finally {
          button.removeAttribute('aria-busy');
          this.busy = false;
        }
      }, { signal: this.abortController.signal });
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }
    openInbox() {
      const modernChat = document.querySelector('shopify-chat');
      if (modernChat && customElements.get('shopify-chat')) {
        if (modernChat.hasAttribute('open')) return true;
        if (typeof modernChat.show === 'function') {
          modernChat.show();
          return true;
        }
        modernChat.setAttribute('open', '');
        return true;
      }
      const hosts = document.querySelectorAll('#ShopifyChat, inbox-online-store-chat');
      for (const host of hosts) {
        const root = host.shadowRoot;
        if (!root) continue;
        const expanded = root.querySelector('button[aria-expanded="true"]');
        const dialog = root.querySelector('[role="dialog"], .chat-window');
        if (expanded || (dialog && dialog.getClientRects().length)) return true;
        const launcher = root.querySelector('button.chat-toggle, .chat-app > button, button[aria-expanded="false"]');
        if (launcher && launcher.getClientRects().length) {
          launcher.click();
          return true;
        }
      }
      return false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fire-live"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('m3-fiere')) {
  customElements.define('m3-fiere', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.filter = 'all';
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.select = this.querySelector('[data-fair]');
      this.day = this.querySelector('[data-day]');
      this.querySelector('[data-filters]').hidden = this.cards.length === 0;
      this.addEventListener('click', event => {
        const filter = event.target.closest('[data-filter]');
        if (filter) { this.filter = filter.dataset.filter; this.applyFilter(); }
        const pick = event.target.closest('[data-pick]');
        if (pick && this.select) {
          const option = [...this.select.options].find(o => o.dataset.id === pick.dataset.pick && !o.disabled);
          if (option) { this.select.value = option.value; this.updateDate(); this.day.focus({ preventScroll: true }); }
        }
      }, { signal });
      if (this.select) {
        this.select.addEventListener('change', () => this.updateDate(), { signal });
        this.day.addEventListener('input', () => this.validateDate(), { signal });
        this.select.form.addEventListener('submit', event => {
          this.updateStates();
          this.updateDate();
          if (!this.select.form.checkValidity()) { event.preventDefault(); this.select.form.reportValidity(); }
        }, { signal });
        this.updateDate();
      }
      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target)) { this.filter = 'all'; this.applyFilter(); }
      }, { signal });
      this.updateStates();
      this.timer = setInterval(() => this.updateStates(), 60000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.controller?.abort(); this.controller = null; }
    applyFilter() {
      this.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.filter === this.filter)));
      this.cards.forEach(c => { c.hidden = this.filter !== 'all' && c.dataset.state !== this.filter; });
      this.querySelector('[data-no-results]').hidden = !this.cards.length || this.cards.some(c => !c.hidden);
    }
    updateStates() {
      const now = Date.now() / 1000;
      this.cards.forEach(card => {
        const start = Number(card.dataset.start), end = Number(card.dataset.end);
        if (!(start > 1000000000 && end > start)) return;
        const state = now >= end ? 'past' : now >= start ? 'ongoing' : 'upcoming';
        card.dataset.state = state;
        const badge = card.querySelector('[data-status]');
        badge.textContent = badge.dataset[state];
        if (state === 'past') card.querySelectorAll('[data-booking]').forEach(a => { a.hidden = true; });
      });
      if (this.select) {
        [...this.select.options].forEach(option => {
          if (option.dataset.endTs && now >= Number(option.dataset.endTs)) {
            option.disabled = true;
            if (option.selected) this.select.value = '';
          }
        });
        this.updateDate();
      }
      this.applyFilter();
    }
    updateDate() {
      const option = this.select.selectedOptions[0];
      let today;
      try {
        const parts = new Intl.DateTimeFormat('en', { timeZone: option?.dataset.zone || 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        const get = type => parts.find(p => p.type === type).value;
        today = `${get('year')}-${get('month')}-${get('day')}`;
      } catch { today = new Date().toISOString().slice(0,10); }
      this.day.min = option?.dataset.start > today ? option.dataset.start : today;
      if (option?.dataset.end) this.day.max = option.dataset.end; else this.day.removeAttribute('max');
      this.validateDate();
    }
    validateDate() {
      const value = this.day.value;
      const invalid = value && (value < this.day.min || (this.day.max && value > this.day.max));
      this.day.setCustomValidity(invalid ? this.dataset.invalidDate : '');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["galleria-prodotti-finiti"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('emmetre-photo-gallery')) {
    class EmmetrePhotoGallery extends HTMLElement {
      static locks = new Set();
      static savedOverflow = [];

      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected && !this.controller) this.initialize(); });
      }

      initialize() {
        this.track = this.querySelector('.epg-track');
        this.dialog = this.querySelector('dialog');
        if (!this.track || !this.dialog) return;
        this.controller = new AbortController();
        const listen = (target, type, handler, options = {}) => target.addEventListener(type, handler, { ...options, signal: this.controller.signal });
        this.photos = [...this.querySelectorAll('[data-photo]')];
        this.stage = this.querySelector('[data-stage]');
        this.status = this.querySelector('[data-status]');
        this.controls = this.querySelector('.epg-track-controls');
        this.previous = this.querySelector('[data-scroll="-1"]');
        this.next = this.querySelector('[data-scroll="1"]');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.renderVersion = 0;
        this.suppressClickUntil = 0;

        this.photos.forEach((photo, index) => {
          if (typeof this.dialog.showModal !== 'function') return;
          photo.setAttribute('aria-haspopup', 'dialog');
          photo.setAttribute('aria-controls', this.dialog.id);
          listen(photo, 'click', event => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            if (performance.now() >= this.suppressClickUntil) this.open(index);
          });
        });
        this.querySelectorAll('[data-scroll]').forEach(button => listen(button, 'click', () => this.scroll(Number(button.dataset.scroll))));
        this.querySelectorAll('[data-step]').forEach(button => {
          button.hidden = this.photos.length < 2;
          listen(button, 'click', () => this.show(this.index + Number(button.dataset.step)));
        });
        listen(this.querySelector('[data-close]'), 'click', () => this.dialog.close());
        listen(this.dialog, 'close', () => this.afterClose());
        listen(this.dialog, 'click', event => {
          if ((event.target === this.stage || event.target === this.dialog) && performance.now() >= this.suppressClickUntil) this.dialog.close();
        });
        listen(this.dialog, 'keydown', event => {
          if (event.key === 'Tab') {
            const buttons = [...this.dialog.querySelectorAll('button')].filter(button => !button.hidden && !button.disabled);
            const first = buttons[0];
            const last = buttons[buttons.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
          }
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            event.stopPropagation();
            this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        listen(this.track, 'keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({left:event.key === 'Home' ? 0 : this.track.scrollWidth, behavior:this.behavior()});
          else this.scroll(event.key === 'ArrowRight' ? 1 : -1);
        });
        listen(this.track, 'scroll', () => {
          if (!this.scrollFrame) this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.updateControls(); });
        }, {passive:true});
        listen(this.track, 'dragstart', event => event.preventDefault());
        listen(this.track, 'pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.drag = {id:event.pointerId, x:event.clientX, y:event.clientY, left:this.track.scrollLeft, active:false};
        });
        listen(window, 'pointermove', event => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) return;
          const dx = event.clientX - drag.x;
          if (!drag.active && Math.abs(dx) > 6 && Math.abs(dx) > Math.abs(event.clientY - drag.y)) {
            drag.active = true;
            this.track.classList.add('is-dragging');
            this.track.setPointerCapture(event.pointerId);
          }
          if (drag.active) { event.preventDefault(); this.track.scrollLeft = drag.left - dx; }
        });
        const endDrag = event => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          if (this.drag.active) this.suppressClickUntil = performance.now() + 350;
          this.drag = null;
          this.track.classList.remove('is-dragging');
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        };
        listen(window, 'pointerup', endDrag);
        listen(window, 'pointercancel', endDrag);
        listen(this.track, 'lostpointercapture', endDrag);
        listen(this.stage, 'pointerdown', event => {
          if (event.pointerType === 'mouse') return;
          if (!event.isPrimary) { this.swipe = null; return; }
          this.swipe = {id:event.pointerId,x:event.clientX,y:event.clientY};
        });
        listen(this.stage, 'pointerup', event => {
          const swipe = this.swipe;
          this.swipe = null;
          if (!swipe || swipe.id !== event.pointerId) return;
          const dx = event.clientX - swipe.x;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(event.clientY - swipe.y) * 1.4) {
            this.suppressClickUntil = performance.now() + 350;
            this.show(this.index + (dx < 0 ? 1 : -1));
          }
        });
        listen(this.stage, 'pointercancel', () => { this.swipe = null; });
        listen(this, 'shopify:block:select', event => {
          const card = [...this.track.children].find(item => item.dataset.blockId === event.detail.blockId);
          if (card) this.track.scrollTo({left:card.offsetLeft - 12,behavior:'instant'});
        });
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.updateControls();
      }

      behavior() { return this.reducedMotion.matches ? 'instant' : 'smooth'; }

      scroll(direction) {
        const card = this.track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({left:direction * (card.getBoundingClientRect().width + gap),behavior:this.behavior()});
      }

      updateControls() {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.controls.hidden = maximum < 2;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maximum - 2;
      }

      open(index) {
        this.opener = this.photos[index];
        this.show(index);
        if (!this.dialog.open) this.dialog.showModal();
        if (!EmmetrePhotoGallery.locks.size) {
          EmmetrePhotoGallery.savedOverflow = [document.documentElement, document.body].map(element => ({element,value:element.style.getPropertyValue('overflow'),priority:element.style.getPropertyPriority('overflow')}));
          EmmetrePhotoGallery.savedOverflow.forEach(({element}) => element.style.setProperty('overflow', 'hidden'));
        }
        EmmetrePhotoGallery.locks.add(this);
      }

      show(index) {
        if (!this.photos.length) return;
        this.index = (index + this.photos.length) % this.photos.length;
        const version = ++this.renderVersion;
        const photo = this.photos[this.index];
        const thumbnail = photo.querySelector('img');
        const image = new Image();
        image.alt = thumbnail.alt;
        image.width = Number(thumbnail.getAttribute('width')) || thumbnail.naturalWidth;
        image.height = Number(thumbnail.getAttribute('height')) || thumbnail.naturalHeight;
        image.draggable = false;
        image.decoding = 'async';
        image.src = thumbnail.currentSrc || thumbnail.src;
        this.stage.replaceChildren(image);
        this.status.textContent = this.dataset.counter.replace('__INDEX__', String(this.index + 1)).replace('__TOTAL__', String(this.photos.length));
        const fullImage = new Image();
        fullImage.onload = () => {
          if (this.renderVersion !== version || !this.isConnected) return;
          image.width = fullImage.naturalWidth;
          image.height = fullImage.naturalHeight;
          image.src = fullImage.src;
        };
        fullImage.src = photo.href;
      }

      afterClose() {
        this.releaseLock();
        this.renderVersion++;
        this.stage.replaceChildren();
        this.status.textContent = '';
        if (this.isConnected && this.opener?.isConnected) this.opener.focus({preventScroll:true});
      }

      releaseLock() {
        if (!EmmetrePhotoGallery.locks.delete(this) || EmmetrePhotoGallery.locks.size) return;
        EmmetrePhotoGallery.savedOverflow.forEach(({element,value,priority}) => {
          if (value) element.style.setProperty('overflow', value, priority);
          else element.style.removeProperty('overflow');
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resizeObserver?.disconnect();
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = null;
        if (this.dialog?.open) this.dialog.close();
        this.releaseLock();
        this.renderVersion++;
        this.drag = null;
        this.swipe = null;
      }
    }
    customElements.define('emmetre-photo-gallery', EmmetrePhotoGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m3-faq-etichette"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', function (event) {
    const item = event.target.closest('.m3faq-etichette__item');
    if (item) item.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m3-faq-generatore"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', function (event) {
    const item = event.target.closest('.m3faq-generatore__item');
    if (item) item.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m3-faq-piani"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('shopify:block:select', function (event) {
    const item = event.target.closest('.m3faq-piani__item');
    if (item) item.open = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["m3-pdp-takeaway-apple"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('m3-client-gallery')) return;
  class M3ClientGallery extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.started) return;
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.original = this.querySelector('[data-original]');
      if (!this.original) return;
      this.started = true;
      this.abort = new AbortController();
      this.reasons = new Set();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.speed = Math.max(10, Math.min(120, Number(this.dataset.speed) || 35));
      this.controls = this.querySelector('[data-controls]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.toggle = this.querySelector('[data-toggle]');
      this.cycle = 0;
      this.lastTime = 0;
      this.frame = 0;
      const on = (target, event, handler, options = {}) => target.addEventListener(event, handler, {...options, signal: this.abort.signal});
      on(this.toggle, 'click', () => {
        this.setReason('user', !this.reasons.has('user'));
        const paused = this.reasons.has('user');
        const label = paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.toggle.setAttribute('aria-label', label);
        this.toggle.title = label;
        this.querySelector('[data-pause-icon]').hidden = paused;
        this.querySelector('[data-play-icon]').hidden = !paused;
      });
      on(this.previous, 'click', () => this.move(-1));
      on(this.next, 'click', () => this.move(1));
      on(this.viewport, 'pointerenter', event => {
        if (event.pointerType === 'mouse' && this.dataset.hoverPause === 'true') this.setReason('hover', true);
      });
      on(this.viewport, 'pointerleave', () => this.setReason('hover', false));
      on(this.viewport, 'focus', () => this.setReason('focus', true));
      on(this.viewport, 'blur', () => this.setReason('focus', false));
      on(this.viewport, 'pointerdown', () => { this.dragging = true; this.setReason('drag', true); }, {passive: true});
      const release = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.cooldown();
        this.setReason('drag', false);
      };
      on(window, 'pointerup', release, {passive: true});
      on(window, 'pointercancel', release, {passive: true});
      on(this.viewport, 'wheel', () => this.cooldown(), {passive: true});
      on(this.viewport, 'scroll', () => this.updateControls(), {passive: true});
      on(this.viewport, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      on(document, 'visibilitychange', () => this.setReason('hidden', document.hidden));
      on(this.motion, 'change', () => this.rebuild());
      on(document, 'shopify:block:select', event => {
        if (!this.original.contains(event.target)) return;
        this.setReason('editor', true);
        const card = event.target.closest('.m3-client-card');
        if (card) {
          this.viewport.scrollLeft += card.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
          this.updateControls();
        }
      });
      on(document, 'shopify:block:deselect', event => {
        if (event.target.contains(this) || this.contains(event.target)) this.setReason('editor', false);
      });
      this.resize = new ResizeObserver(() => this.rebuild());
      this.resize.observe(this.viewport);
      this.resize.observe(this.original);
      if ('IntersectionObserver' in window) {
        this.intersection = new IntersectionObserver(entries => this.setReason('offscreen', !entries[0].isIntersecting));
        this.intersection.observe(this);
      }
      this.setReason('hidden', document.hidden);
      this.rebuild();
    }
    rebuild() {
      if (!this.started) return;
      const oldCycle = this.cycle;
      const position = oldCycle ? (this.viewport.scrollLeft % oldCycle) / oldCycle : 0;
      this.track.querySelectorAll('[data-copy]').forEach(node => node.remove());
      this.loop = this.dataset.autoplay === 'true' && !this.motion.matches && this.original.children.length > 1;
      this.cycle = this.original.getBoundingClientRect().width;
      if (this.cycle <= 0 || this.viewport.clientWidth <= 0) {
        this.loop = false;
        this.sync();
        return;
      }
      if (this.loop) {
        const copies = Math.ceil(this.viewport.clientWidth / this.cycle) + 1;
        for (let i = 0; i < copies; i++) {
          const copy = this.original.cloneNode(true);
          copy.removeAttribute('data-original');
          copy.setAttribute('data-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          copy.inert = true;
          copy.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
          copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          copy.querySelectorAll('img').forEach(img => { img.loading = 'eager'; img.alt = ''; });
          this.track.append(copy);
        }
      }
      this.viewport.scrollLeft = position * this.cycle;
      this.position = this.viewport.scrollLeft;
      this.lastTime = 0;
      this.toggle.hidden = !this.loop;
      this.updateControls();
      this.sync();
    }
    updateControls() {
      const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      this.controls.hidden = !this.loop && max <= 1;
      this.previous.disabled = !this.loop && this.viewport.scrollLeft <= 1;
      this.next.disabled = !this.loop && this.viewport.scrollLeft >= max - 1;
    }
    setReason(reason, active) {
      if (active) this.reasons.add(reason); else this.reasons.delete(reason);
      this.sync();
    }
    cooldown() {
      clearTimeout(this.resumeTimer);
      this.setReason('interaction', true);
      this.resumeTimer = setTimeout(() => this.setReason('interaction', false), 1800);
    }
    move(direction) {
      this.cooldown();
      const card = this.original.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.original).columnGap) || 0;
      const target = this.viewport.scrollLeft + direction * (card.getBoundingClientRect().width + gap);
      this.viewport.scrollLeft = this.loop ? ((target % this.cycle) + this.cycle) % this.cycle : target;
      this.updateControls();
    }
    sync() {
      if (!this.started) return;
      const run = this.loop && this.reasons.size === 0;
      if (!run) {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.lastTime = 0;
      } else if (!this.frame) {
        this.position = this.viewport.scrollLeft % this.cycle;
        this.frame = requestAnimationFrame(time => this.tick(time));
      }
    }
    tick(time) {
      this.frame = 0;
      if (!this.started || !this.loop || this.reasons.size) return;
      if (this.lastTime) {
        const elapsed = Math.min(50, time - this.lastTime) / 1000;
        this.position = (this.position + elapsed * this.speed) % this.cycle;
        this.viewport.scrollLeft = this.position;
      }
      this.lastTime = time;
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    disconnectedCallback() {
      this.started = false;
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.frame);
      clearTimeout(this.resumeTimer);
      this.abort?.abort();
      this.resize?.disconnect();
      this.intersection?.disconnect();
      this.track?.querySelectorAll('[data-copy]').forEach(node => node.remove());
    }
  }
  customElements.define('m3-client-gallery', M3ClientGallery);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-kit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('media-kit-library')) {
    customElements.define('media-kit-library', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        if (this.tabs.length) {
          this.querySelector('[role="tablist"]').hidden = false;
          this.panels.forEach(panel => {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', this.tabs.find(tab => tab.dataset.tab === panel.dataset.panel).id);
            panel.tabIndex = 0;
          });
          this.selectTab('brand');
          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.selectTab(tab.dataset.tab), options);
            tab.addEventListener('keydown', event => {
              let next;
              if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
              if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
              if (event.key === 'Home') next = 0;
              if (event.key === 'End') next = this.tabs.length - 1;
              if (next === undefined) return;
              event.preventDefault();
              this.selectTab(this.tabs[next].dataset.tab);
              this.tabs[next].focus();
            }, options);
          });
        }
        this.querySelectorAll('[data-copy]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', async () => {
            const status = this.querySelector('[role="status"]');
            try {
              await navigator.clipboard.writeText(button.dataset.copy);
              status.textContent = `${this.dataset.copied} ${button.dataset.copy}`;
            } catch {
              status.textContent = `${this.dataset.copyError} ${button.dataset.copy}`;
            }
          }, options);
        });
        this.querySelectorAll('[data-mk-download]').forEach(link => {
          link.addEventListener('click', async event => {
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            if (link.getAttribute('aria-busy') === 'true') return;
            const status = this.querySelector('[role="status"]');
            link.setAttribute('aria-busy', 'true');
            status.textContent = this.dataset.downloading;
            try {
              const response = await fetch(link.href, { credentials: 'omit', signal: this.controller.signal });
              if (!response.ok) throw new Error('Download failed');
              const blob = await response.blob();
              const filename = decodeURIComponent(new URL(link.href).pathname.split('/').pop() || 'media-kit');
              const objectURL = URL.createObjectURL(blob);
              const download = document.createElement('a');
              download.href = objectURL;
              download.download = filename;
              download.hidden = true;
              document.body.appendChild(download);
              download.click();
              download.remove();
              setTimeout(() => URL.revokeObjectURL(objectURL), 60000);
              status.textContent = this.dataset.downloadReady;
            } catch (error) {
              if (error.name === 'AbortError') return;
              status.textContent = this.dataset.downloadError + ' ';
              const fallback = document.createElement('a');
              fallback.href = link.href;
              fallback.target = '_blank';
              fallback.rel = 'noopener';
              fallback.textContent = this.dataset.saveManually;
              fallback.style.textDecoration = 'underline';
              status.appendChild(fallback);
            } finally {
              link.removeAttribute('aria-busy');
            }
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-panel]');
          if (panel && this.tabs.length) this.selectTab(panel.dataset.panel);
        }, options);
      }
      selectTab(key) {
        this.tabs.forEach(tab => {
          const selected = tab.dataset.tab === key;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== key; });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prodotti-cina"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('emmetre-catalogo')) {
    customElements.define('emmetre-catalogo', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.track = this.querySelector('.ec-track');
        this.catalog = this.querySelector('.ec-catalog');
        this.details = this.querySelector('.ec-details');
        this.selection = this.querySelector('select[name="contact[Prodotto]"]');
        this.classList.add('is-ready');
        this.querySelector('.ec-navigation').hidden = false;
        if (this.details) this.querySelector('.ec-back').hidden = false;
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const card = this.track.querySelector('.ec-card');
            if (!card) return;
            const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
            this.track.scrollBy({ left: step * Number(button.dataset.direction) });
          }, options);
        });
        this.querySelectorAll('[data-quote]').forEach(link => {
          link.addEventListener('click', event => {
            if (!this.details || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.opener = link;
            const option = Array.from(this.selection?.options || []).find(item => item.dataset.productId === link.dataset.productId);
            if (option) this.selection.selectedIndex = option.index;
            this.details.open = true;
            this.showRequest();
            this.details.scrollIntoView({ block: 'start' });
            (this.selection || this.querySelector('.ec-back')).focus({ preventScroll: true });
          }, options);
        });
        this.querySelector('.ec-back')?.addEventListener('click', () => {
          if (this.details) this.details.open = false;
          this.catalog.hidden = false;
          this.updateArrows();
          const target = this.opener || this.querySelector('.ec-request');
          if (target) target.focus({ preventScroll: true });
          this.scrollIntoView({ block: 'start' });
        }, options);
        this.details?.addEventListener('toggle', () => this.showRequest(), options);
        this.track.addEventListener('scroll', () => this.updateArrows(), { ...options, passive: true });
        this.observer = new ResizeObserver(() => this.updateArrows());
        this.observer.observe(this.track);
        const photo = this.querySelector('.ec-photo');
        if (photo) this.observer.observe(photo);
        this.addEventListener('shopify:block:select', event => {
          if (this.details) this.details.open = false;
          this.catalog.hidden = false;
          const card = event.target.closest('.ec-card');
          if (card) card.scrollIntoView({ block: 'nearest', inline: 'center' });
        }, options);
        this.showRequest();
      }
      showRequest() {
        this.catalog.hidden = Boolean(this.details?.open);
        if (!this.details?.open) this.updateArrows();
      }
      updateArrows() {
        if (this.catalog.hidden) return;
        const photo = this.querySelector('.ec-photo');
        if (photo) {
          const imageRect = photo.getBoundingClientRect();
          const carouselRect = this.querySelector('.ec-carousel').getBoundingClientRect();
          this.style.setProperty('--ec-arrow-y', `${imageRect.top - carouselRect.top + imageRect.height / 2}px`);
        }
        this.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft <= 2;
        this.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prodottistampati"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('m3-client-gallery')) return;
  class M3ClientGallery extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.started) return;
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      this.original = this.querySelector('[data-original]');
      if (!this.original) return;
      this.started = true;
      this.abort = new AbortController();
      this.reasons = new Set();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.speed = Math.max(10, Math.min(120, Number(this.dataset.speed) || 35));
      this.controls = this.querySelector('[data-controls]');
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.toggle = this.querySelector('[data-toggle]');
      this.cycle = 0;
      this.lastTime = 0;
      this.frame = 0;
      const on = (target, event, handler, options = {}) => target.addEventListener(event, handler, {...options, signal: this.abort.signal});
      on(this.toggle, 'click', () => {
        this.setReason('user', !this.reasons.has('user'));
        const paused = this.reasons.has('user');
        const label = paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.toggle.setAttribute('aria-label', label);
        this.toggle.title = label;
        this.querySelector('[data-pause-icon]').hidden = paused;
        this.querySelector('[data-play-icon]').hidden = !paused;
      });
      on(this.previous, 'click', () => this.move(-1));
      on(this.next, 'click', () => this.move(1));
      on(this.viewport, 'pointerenter', event => {
        if (event.pointerType === 'mouse' && this.dataset.hoverPause === 'true') this.setReason('hover', true);
      });
      on(this.viewport, 'pointerleave', () => this.setReason('hover', false));
      on(this.viewport, 'focus', () => this.setReason('focus', true));
      on(this.viewport, 'blur', () => this.setReason('focus', false));
      on(this.viewport, 'pointerdown', () => { this.dragging = true; this.setReason('drag', true); }, {passive: true});
      const release = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.cooldown();
        this.setReason('drag', false);
      };
      on(window, 'pointerup', release, {passive: true});
      on(window, 'pointercancel', release, {passive: true});
      on(this.viewport, 'wheel', () => this.cooldown(), {passive: true});
      on(this.viewport, 'scroll', () => this.updateControls(), {passive: true});
      on(this.viewport, 'keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowLeft' ? -1 : 1);
      });
      on(document, 'visibilitychange', () => this.setReason('hidden', document.hidden));
      on(this.motion, 'change', () => this.rebuild());
      on(document, 'shopify:block:select', event => {
        if (!this.original.contains(event.target)) return;
        this.setReason('editor', true);
        const card = event.target.closest('.m3-client-card');
        if (card) {
          this.viewport.scrollLeft += card.getBoundingClientRect().left - this.viewport.getBoundingClientRect().left;
          this.updateControls();
        }
      });
      on(document, 'shopify:block:deselect', event => {
        if (event.target.contains(this) || this.contains(event.target)) this.setReason('editor', false);
      });
      this.resize = new ResizeObserver(() => this.rebuild());
      this.resize.observe(this.viewport);
      this.resize.observe(this.original);
      if ('IntersectionObserver' in window) {
        this.intersection = new IntersectionObserver(entries => this.setReason('offscreen', !entries[0].isIntersecting));
        this.intersection.observe(this);
      }
      this.setReason('hidden', document.hidden);
      this.rebuild();
    }
    rebuild() {
      if (!this.started) return;
      const oldCycle = this.cycle;
      const position = oldCycle ? (this.viewport.scrollLeft % oldCycle) / oldCycle : 0;
      this.track.querySelectorAll('[data-copy]').forEach(node => node.remove());
      this.loop = this.dataset.autoplay === 'true' && !this.motion.matches && this.original.children.length > 1;
      this.cycle = this.original.getBoundingClientRect().width;
      if (this.cycle <= 0 || this.viewport.clientWidth <= 0) {
        this.loop = false;
        this.sync();
        return;
      }
      if (this.loop) {
        const copies = Math.ceil(this.viewport.clientWidth / this.cycle) + 1;
        for (let i = 0; i < copies; i++) {
          const copy = this.original.cloneNode(true);
          copy.removeAttribute('data-original');
          copy.setAttribute('data-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          copy.inert = true;
          copy.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
          copy.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          copy.querySelectorAll('img').forEach(img => { img.loading = 'eager'; img.alt = ''; });
          this.track.append(copy);
        }
      }
      this.viewport.scrollLeft = position * this.cycle;
      this.position = this.viewport.scrollLeft;
      this.lastTime = 0;
      this.toggle.hidden = !this.loop;
      this.updateControls();
      this.sync();
    }
    updateControls() {
      const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      this.controls.hidden = !this.loop && max <= 1;
      this.previous.disabled = !this.loop && this.viewport.scrollLeft <= 1;
      this.next.disabled = !this.loop && this.viewport.scrollLeft >= max - 1;
    }
    setReason(reason, active) {
      if (active) this.reasons.add(reason); else this.reasons.delete(reason);
      this.sync();
    }
    cooldown() {
      clearTimeout(this.resumeTimer);
      this.setReason('interaction', true);
      this.resumeTimer = setTimeout(() => this.setReason('interaction', false), 1800);
    }
    move(direction) {
      this.cooldown();
      const card = this.original.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.original).columnGap) || 0;
      const target = this.viewport.scrollLeft + direction * (card.getBoundingClientRect().width + gap);
      this.viewport.scrollLeft = this.loop ? ((target % this.cycle) + this.cycle) % this.cycle : target;
      this.updateControls();
    }
    sync() {
      if (!this.started) return;
      const run = this.loop && this.reasons.size === 0;
      if (!run) {
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.lastTime = 0;
      } else if (!this.frame) {
        this.position = this.viewport.scrollLeft % this.cycle;
        this.frame = requestAnimationFrame(time => this.tick(time));
      }
    }
    tick(time) {
      this.frame = 0;
      if (!this.started || !this.loop || this.reasons.size) return;
      if (this.lastTime) {
        const elapsed = Math.min(50, time - this.lastTime) / 1000;
        this.position = (this.position + elapsed * this.speed) % this.cycle;
        this.viewport.scrollLeft = this.position;
      }
      this.lastTime = time;
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    disconnectedCallback() {
      this.started = false;
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.frame);
      clearTimeout(this.resumeTimer);
      this.abort?.abort();
      this.resize?.disconnect();
      this.intersection?.disconnect();
      this.track?.querySelectorAll('[data-copy]').forEach(node => node.remove());
    }
  }
  customElements.define('m3-client-gallery', M3ClientGallery);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qr-codegenerator"] && !Shopify.designMode) return;
  try {
    
(function(){
/*
MIT License

Copyright (c) 2009 Kazuhiko Arase

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/
var qrcode=function(){var t=function(t,r){var e=t,n=g[r],o=null,i=0,a=null,u=[],f={},c=function(t,r){o=function(t){for(var r=new Array(t),e=0;e<t;e+=1){r[e]=new Array(t);for(var n=0;n<t;n+=1)r[e][n]=null}return r}(i=4*e+17),l(0,0),l(i-7,0),l(0,i-7),s(),h(),d(t,r),e>=7&&v(t),null==a&&(a=p(e,n,u)),w(a,r)},l=function(t,r){for(var e=-1;e<=7;e+=1)if(!(t+e<=-1||i<=t+e))for(var n=-1;n<=7;n+=1)r+n<=-1||i<=r+n||(o[t+e][r+n]=0<=e&&e<=6&&(0==n||6==n)||0<=n&&n<=6&&(0==e||6==e)||2<=e&&e<=4&&2<=n&&n<=4)},h=function(){for(var t=8;t<i-8;t+=1)null==o[t][6]&&(o[t][6]=t%2==0);for(var r=8;r<i-8;r+=1)null==o[6][r]&&(o[6][r]=r%2==0)},s=function(){for(var t=B.getPatternPosition(e),r=0;r<t.length;r+=1)for(var n=0;n<t.length;n+=1){var i=t[r],a=t[n];if(null==o[i][a])for(var u=-2;u<=2;u+=1)for(var f=-2;f<=2;f+=1)o[i+u][a+f]=-2==u||2==u||-2==f||2==f||0==u&&0==f}},v=function(t){for(var r=B.getBCHTypeNumber(e),n=0;n<18;n+=1){var a=!t&&1==(r>>n&1);o[Math.floor(n/3)][n%3+i-8-3]=a}for(n=0;n<18;n+=1){a=!t&&1==(r>>n&1);o[n%3+i-8-3][Math.floor(n/3)]=a}},d=function(t,r){for(var e=n<<3|r,a=B.getBCHTypeInfo(e),u=0;u<15;u+=1){var f=!t&&1==(a>>u&1);u<6?o[u][8]=f:u<8?o[u+1][8]=f:o[i-15+u][8]=f}for(u=0;u<15;u+=1){f=!t&&1==(a>>u&1);u<8?o[8][i-u-1]=f:u<9?o[8][15-u-1+1]=f:o[8][15-u-1]=f}o[i-8][8]=!t},w=function(t,r){for(var e=-1,n=i-1,a=7,u=0,f=B.getMaskFunction(r),c=i-1;c>0;c-=2)for(6==c&&(c-=1);;){for(var g=0;g<2;g+=1)if(null==o[n][c-g]){var l=!1;u<t.length&&(l=1==(t[u]>>>a&1)),f(n,c-g)&&(l=!l),o[n][c-g]=l,-1==(a-=1)&&(u+=1,a=7)}if((n+=e)<0||i<=n){n-=e,e=-e;break}}},p=function(t,r,e){for(var n=A.getRSBlocks(t,r),o=b(),i=0;i<e.length;i+=1){var a=e[i];o.put(a.getMode(),4),o.put(a.getLength(),B.getLengthInBits(a.getMode(),t)),a.write(o)}var u=0;for(i=0;i<n.length;i+=1)u+=n[i].dataCount;if(o.getLengthInBits()>8*u)throw"code length overflow. ("+o.getLengthInBits()+">"+8*u+")";for(o.getLengthInBits()+4<=8*u&&o.put(0,4);o.getLengthInBits()%8!=0;)o.putBit(!1);for(;!(o.getLengthInBits()>=8*u||(o.put(236,8),o.getLengthInBits()>=8*u));)o.put(17,8);return function(t,r){for(var e=0,n=0,o=0,i=new Array(r.length),a=new Array(r.length),u=0;u<r.length;u+=1){var f=r[u].dataCount,c=r[u].totalCount-f;n=Math.max(n,f),o=Math.max(o,c),i[u]=new Array(f);for(var g=0;g<i[u].length;g+=1)i[u][g]=255&t.getBuffer()[g+e];e+=f;var l=B.getErrorCorrectPolynomial(c),h=k(i[u],l.getLength()-1).mod(l);for(a[u]=new Array(l.getLength()-1),g=0;g<a[u].length;g+=1){var s=g+h.getLength()-a[u].length;a[u][g]=s>=0?h.getAt(s):0}}var v=0;for(g=0;g<r.length;g+=1)v+=r[g].totalCount;var d=new Array(v),w=0;for(g=0;g<n;g+=1)for(u=0;u<r.length;u+=1)g<i[u].length&&(d[w]=i[u][g],w+=1);for(g=0;g<o;g+=1)for(u=0;u<r.length;u+=1)g<a[u].length&&(d[w]=a[u][g],w+=1);return d}(o,n)};f.addData=function(t,r){var e=null;switch(r=r||"Byte"){case"Numeric":e=M(t);break;case"Alphanumeric":e=x(t);break;case"Byte":e=m(t);break;case"Kanji":e=L(t);break;default:throw"mode:"+r}u.push(e),a=null},f.isDark=function(t,r){if(t<0||i<=t||r<0||i<=r)throw t+","+r;return o[t][r]},f.getModuleCount=function(){return i},f.make=function(){if(e<1){for(var t=1;t<40;t++){for(var r=A.getRSBlocks(t,n),o=b(),i=0;i<u.length;i++){var a=u[i];o.put(a.getMode(),4),o.put(a.getLength(),B.getLengthInBits(a.getMode(),t)),a.write(o)}var g=0;for(i=0;i<r.length;i++)g+=r[i].dataCount;if(o.getLengthInBits()<=8*g)break}e=t}c(!1,function(){for(var t=0,r=0,e=0;e<8;e+=1){c(!0,e);var n=B.getLostPoint(f);(0==e||t>n)&&(t=n,r=e)}return r}())},f.createTableTag=function(t,r){t=t||2;var e="";e+='<table style="',e+=" border-width: 0px; border-style: none;",e+=" border-collapse: collapse;",e+=" padding: 0px; margin: "+(r=void 0===r?4*t:r)+"px;",e+='">',e+="<tbody>";for(var n=0;n<f.getModuleCount();n+=1){e+="<tr>";for(var o=0;o<f.getModuleCount();o+=1)e+='<td style="',e+=" border-width: 0px; border-style: none;",e+=" border-collapse: collapse;",e+=" padding: 0px; margin: 0px;",e+=" width: "+t+"px;",e+=" height: "+t+"px;",e+=" background-color: ",e+=f.isDark(n,o)?"#000000":"#ffffff",e+=";",e+='"/>';e+="</tr>"}return e+="</tbody>",e+="</table>"},f.createSvgTag=function(t,r,e,n){var o={};"object"==typeof arguments[0]&&(t=(o=arguments[0]).cellSize,r=o.margin,e=o.alt,n=o.title),t=t||2,r=void 0===r?4*t:r,(e="string"==typeof e?{text:e}:e||{}).text=e.text||null,e.id=e.text?e.id||"qrcode-description":null,(n="string"==typeof n?{text:n}:n||{}).text=n.text||null,n.id=n.text?n.id||"qrcode-title":null;var i,a,u,c,g=f.getModuleCount()*t+2*r,l="";for(c="l"+t+",0 0,"+t+" -"+t+",0 0,-"+t+"z ",l+='<svg version="1.1" xmlns="http://www.w3.org/2000/svg"',l+=o.scalable?"":' width="'+g+'px" height="'+g+'px"',l+=' viewBox="0 0 '+g+" "+g+'" ',l+=' preserveAspectRatio="xMinYMin meet"',l+=n.text||e.text?' role="img" aria-labelledby="'+y([n.id,e.id].join(" ").trim())+'"':"",l+=">",l+=n.text?'<title id="'+y(n.id)+'">'+y(n.text)+"</title>":"",l+=e.text?'<description id="'+y(e.id)+'">'+y(e.text)+"</description>":"",l+='<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>',l+='<path d="',a=0;a<f.getModuleCount();a+=1)for(u=a*t+r,i=0;i<f.getModuleCount();i+=1)f.isDark(a,i)&&(l+="M"+(i*t+r)+","+u+c);return l+='" stroke="transparent" fill="black"/>',l+="</svg>"},f.createDataURL=function(t,r){t=t||2,r=void 0===r?4*t:r;var e=f.getModuleCount()*t+2*r,n=r,o=e-r;return I(e,e,function(r,e){if(n<=r&&r<o&&n<=e&&e<o){var i=Math.floor((r-n)/t),a=Math.floor((e-n)/t);return f.isDark(a,i)?0:1}return 1})},f.createImgTag=function(t,r,e){t=t||2,r=void 0===r?4*t:r;var n=f.getModuleCount()*t+2*r,o="";return o+="<img",o+=' src="',o+=f.createDataURL(t,r),o+='"',o+=' width="',o+=n,o+='"',o+=' height="',o+=n,o+='"',e&&(o+=' alt="',o+=y(e),o+='"'),o+="/>"};var y=function(t){for(var r="",e=0;e<t.length;e+=1){var n=t.charAt(e);switch(n){case"<":r+="&lt;";break;case">":r+="&gt;";break;case"&":r+="&amp;";break;case'"':r+="&quot;";break;default:r+=n}}return r};return f.createASCII=function(t,r){if((t=t||1)<2)return function(t){t=void 0===t?2:t;var r,e,n,o,i,a=1*f.getModuleCount()+2*t,u=t,c=a-t,g={"██":"█","█ ":"▀"," █":"▄","  ":" "},l={"██":"▀","█ ":"▀"," █":" ","  ":" "},h="";for(r=0;r<a;r+=2){for(n=Math.floor((r-u)/1),o=Math.floor((r+1-u)/1),e=0;e<a;e+=1)i="█",u<=e&&e<c&&u<=r&&r<c&&f.isDark(n,Math.floor((e-u)/1))&&(i=" "),u<=e&&e<c&&u<=r+1&&r+1<c&&f.isDark(o,Math.floor((e-u)/1))?i+=" ":i+="█",h+=t<1&&r+1>=c?l[i]:g[i];h+="\n"}return a%2&&t>0?h.substring(0,h.length-a-1)+Array(a+1).join("▀"):h.substring(0,h.length-1)}(r);t-=1,r=void 0===r?2*t:r;var e,n,o,i,a=f.getModuleCount()*t+2*r,u=r,c=a-r,g=Array(t+1).join("██"),l=Array(t+1).join("  "),h="",s="";for(e=0;e<a;e+=1){for(o=Math.floor((e-u)/t),s="",n=0;n<a;n+=1)i=1,u<=n&&n<c&&u<=e&&e<c&&f.isDark(o,Math.floor((n-u)/t))&&(i=0),s+=i?g:l;for(o=0;o<t;o+=1)h+=s+"\n"}return h.substring(0,h.length-1)},f.renderTo2dContext=function(t,r){r=r||2;for(var e=f.getModuleCount(),n=0;n<e;n++)for(var o=0;o<e;o++)t.fillStyle=f.isDark(n,o)?"black":"white",t.fillRect(o*r,n*r,r,r)},f};t.stringToBytes=(t.stringToBytesFuncs={default:function(t){for(var r=[],e=0;e<t.length;e+=1){var n=t.charCodeAt(e);r.push(255&n)}return r}}).default,t.createStringToBytes=function(t,r){var e=function(){for(var e=S(t),n=function(){var t=e.read();if(-1==t)throw"eof";return t},o=0,i={};;){var a=e.read();if(-1==a)break;var u=n(),f=n()<<8|n();i[String.fromCharCode(a<<8|u)]=f,o+=1}if(o!=r)throw o+" != "+r;return i}(),n="?".charCodeAt(0);return function(t){for(var r=[],o=0;o<t.length;o+=1){var i=t.charCodeAt(o);if(i<128)r.push(i);else{var a=e[t.charAt(o)];"number"==typeof a?(255&a)==a?r.push(a):(r.push(a>>>8),r.push(255&a)):r.push(n)}}return r}};var r,e,n,o,i,a=1,u=2,f=4,c=8,g={L:1,M:0,Q:3,H:2},l=0,h=1,s=2,v=3,d=4,w=5,p=6,y=7,B=(r=[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],e=1335,n=7973,i=function(t){for(var r=0;0!=t;)r+=1,t>>>=1;return r},(o={}).getBCHTypeInfo=function(t){for(var r=t<<10;i(r)-i(e)>=0;)r^=e<<i(r)-i(e);return 21522^(t<<10|r)},o.getBCHTypeNumber=function(t){for(var r=t<<12;i(r)-i(n)>=0;)r^=n<<i(r)-i(n);return t<<12|r},o.getPatternPosition=function(t){return r[t-1]},o.getMaskFunction=function(t){switch(t){case l:return function(t,r){return(t+r)%2==0};case h:return function(t,r){return t%2==0};case s:return function(t,r){return r%3==0};case v:return function(t,r){return(t+r)%3==0};case d:return function(t,r){return(Math.floor(t/2)+Math.floor(r/3))%2==0};case w:return function(t,r){return t*r%2+t*r%3==0};case p:return function(t,r){return(t*r%2+t*r%3)%2==0};case y:return function(t,r){return(t*r%3+(t+r)%2)%2==0};default:throw"bad maskPattern:"+t}},o.getErrorCorrectPolynomial=function(t){for(var r=k([1],0),e=0;e<t;e+=1)r=r.multiply(k([1,C.gexp(e)],0));return r},o.getLengthInBits=function(t,r){if(1<=r&&r<10)switch(t){case a:return 10;case u:return 9;case f:case c:return 8;default:throw"mode:"+t}else if(r<27)switch(t){case a:return 12;case u:return 11;case f:return 16;case c:return 10;default:throw"mode:"+t}else{if(!(r<41))throw"type:"+r;switch(t){case a:return 14;case u:return 13;case f:return 16;case c:return 12;default:throw"mode:"+t}}},o.getLostPoint=function(t){for(var r=t.getModuleCount(),e=0,n=0;n<r;n+=1)for(var o=0;o<r;o+=1){for(var i=0,a=t.isDark(n,o),u=-1;u<=1;u+=1)if(!(n+u<0||r<=n+u))for(var f=-1;f<=1;f+=1)o+f<0||r<=o+f||0==u&&0==f||a==t.isDark(n+u,o+f)&&(i+=1);i>5&&(e+=3+i-5)}for(n=0;n<r-1;n+=1)for(o=0;o<r-1;o+=1){var c=0;t.isDark(n,o)&&(c+=1),t.isDark(n+1,o)&&(c+=1),t.isDark(n,o+1)&&(c+=1),t.isDark(n+1,o+1)&&(c+=1),0!=c&&4!=c||(e+=3)}for(n=0;n<r;n+=1)for(o=0;o<r-6;o+=1)t.isDark(n,o)&&!t.isDark(n,o+1)&&t.isDark(n,o+2)&&t.isDark(n,o+3)&&t.isDark(n,o+4)&&!t.isDark(n,o+5)&&t.isDark(n,o+6)&&(e+=40);for(o=0;o<r;o+=1)for(n=0;n<r-6;n+=1)t.isDark(n,o)&&!t.isDark(n+1,o)&&t.isDark(n+2,o)&&t.isDark(n+3,o)&&t.isDark(n+4,o)&&!t.isDark(n+5,o)&&t.isDark(n+6,o)&&(e+=40);var g=0;for(o=0;o<r;o+=1)for(n=0;n<r;n+=1)t.isDark(n,o)&&(g+=1);return e+=Math.abs(100*g/r/r-50)/5*10},o),C=function(){for(var t=new Array(256),r=new Array(256),e=0;e<8;e+=1)t[e]=1<<e;for(e=8;e<256;e+=1)t[e]=t[e-4]^t[e-5]^t[e-6]^t[e-8];for(e=0;e<255;e+=1)r[t[e]]=e;var n={glog:function(t){if(t<1)throw"glog("+t+")";return r[t]},gexp:function(r){for(;r<0;)r+=255;for(;r>=256;)r-=255;return t[r]}};return n}();function k(t,r){if(void 0===t.length)throw t.length+"/"+r;var e=function(){for(var e=0;e<t.length&&0==t[e];)e+=1;for(var n=new Array(t.length-e+r),o=0;o<t.length-e;o+=1)n[o]=t[o+e];return n}(),n={getAt:function(t){return e[t]},getLength:function(){return e.length},multiply:function(t){for(var r=new Array(n.getLength()+t.getLength()-1),e=0;e<n.getLength();e+=1)for(var o=0;o<t.getLength();o+=1)r[e+o]^=C.gexp(C.glog(n.getAt(e))+C.glog(t.getAt(o)));return k(r,0)},mod:function(t){if(n.getLength()-t.getLength()<0)return n;for(var r=C.glog(n.getAt(0))-C.glog(t.getAt(0)),e=new Array(n.getLength()),o=0;o<n.getLength();o+=1)e[o]=n.getAt(o);for(o=0;o<t.getLength();o+=1)e[o]^=C.gexp(C.glog(t.getAt(o))+r);return k(e,0).mod(t)}};return n}var A=function(){var t=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12,7,37,13],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]],r=function(t,r){var e={};return e.totalCount=t,e.dataCount=r,e},e={};return e.getRSBlocks=function(e,n){var o=function(r,e){switch(e){case g.L:return t[4*(r-1)+0];case g.M:return t[4*(r-1)+1];case g.Q:return t[4*(r-1)+2];case g.H:return t[4*(r-1)+3];default:return}}(e,n);if(void 0===o)throw"bad rs block @ typeNumber:"+e+"/errorCorrectionLevel:"+n;for(var i=o.length/3,a=[],u=0;u<i;u+=1)for(var f=o[3*u+0],c=o[3*u+1],l=o[3*u+2],h=0;h<f;h+=1)a.push(r(c,l));return a},e}(),b=function(){var t=[],r=0,e={getBuffer:function(){return t},getAt:function(r){var e=Math.floor(r/8);return 1==(t[e]>>>7-r%8&1)},put:function(t,r){for(var n=0;n<r;n+=1)e.putBit(1==(t>>>r-n-1&1))},getLengthInBits:function(){return r},putBit:function(e){var n=Math.floor(r/8);t.length<=n&&t.push(0),e&&(t[n]|=128>>>r%8),r+=1}};return e},M=function(t){var r=a,e=t,n={getMode:function(){return r},getLength:function(t){return e.length},write:function(t){for(var r=e,n=0;n+2<r.length;)t.put(o(r.substring(n,n+3)),10),n+=3;n<r.length&&(r.length-n==1?t.put(o(r.substring(n,n+1)),4):r.length-n==2&&t.put(o(r.substring(n,n+2)),7))}},o=function(t){for(var r=0,e=0;e<t.length;e+=1)r=10*r+i(t.charAt(e));return r},i=function(t){if("0"<=t&&t<="9")return t.charCodeAt(0)-"0".charCodeAt(0);throw"illegal char :"+t};return n},x=function(t){var r=u,e=t,n={getMode:function(){return r},getLength:function(t){return e.length},write:function(t){for(var r=e,n=0;n+1<r.length;)t.put(45*o(r.charAt(n))+o(r.charAt(n+1)),11),n+=2;n<r.length&&t.put(o(r.charAt(n)),6)}},o=function(t){if("0"<=t&&t<="9")return t.charCodeAt(0)-"0".charCodeAt(0);if("A"<=t&&t<="Z")return t.charCodeAt(0)-"A".charCodeAt(0)+10;switch(t){case" ":return 36;case"$":return 37;case"%":return 38;case"*":return 39;case"+":return 40;case"-":return 41;case".":return 42;case"/":return 43;case":":return 44;default:throw"illegal char :"+t}};return n},m=function(r){var e=f,n=t.stringToBytes(r),o={getMode:function(){return e},getLength:function(t){return n.length},write:function(t){for(var r=0;r<n.length;r+=1)t.put(n[r],8)}};return o},L=function(r){var e=c,n=t.stringToBytesFuncs.SJIS;if(!n)throw"sjis not supported.";!function(){var t=n("友");if(2!=t.length||38726!=(t[0]<<8|t[1]))throw"sjis not supported."}();var o=n(r),i={getMode:function(){return e},getLength:function(t){return~~(o.length/2)},write:function(t){for(var r=o,e=0;e+1<r.length;){var n=(255&r[e])<<8|255&r[e+1];if(33088<=n&&n<=40956)n-=33088;else{if(!(57408<=n&&n<=60351))throw"illegal char at "+(e+1)+"/"+n;n-=49472}n=192*(n>>>8&255)+(255&n),t.put(n,13),e+=2}if(e<r.length)throw"illegal char at "+(e+1)}};return i},D=function(){var t=[],r={writeByte:function(r){t.push(255&r)},writeShort:function(t){r.writeByte(t),r.writeByte(t>>>8)},writeBytes:function(t,e,n){e=e||0,n=n||t.length;for(var o=0;o<n;o+=1)r.writeByte(t[o+e])},writeString:function(t){for(var e=0;e<t.length;e+=1)r.writeByte(t.charCodeAt(e))},toByteArray:function(){return t},toString:function(){var r="";r+="[";for(var e=0;e<t.length;e+=1)e>0&&(r+=","),r+=t[e];return r+="]"}};return r},S=function(t){var r=t,e=0,n=0,o=0,i={read:function(){for(;o<8;){if(e>=r.length){if(0==o)return-1;throw"unexpected end of file./"+o}var t=r.charAt(e);if(e+=1,"="==t)return o=0,-1;t.match(/^\s$/)||(n=n<<6|a(t.charCodeAt(0)),o+=6)}var i=n>>>o-8&255;return o-=8,i}},a=function(t){if(65<=t&&t<=90)return t-65;if(97<=t&&t<=122)return t-97+26;if(48<=t&&t<=57)return t-48+52;if(43==t)return 62;if(47==t)return 63;throw"c:"+t};return i},I=function(t,r,e){for(var n=function(t,r){var e=t,n=r,o=new Array(t*r),i={setPixel:function(t,r,n){o[r*e+t]=n},write:function(t){t.writeString("GIF87a"),t.writeShort(e),t.writeShort(n),t.writeByte(128),t.writeByte(0),t.writeByte(0),t.writeByte(0),t.writeByte(0),t.writeByte(0),t.writeByte(255),t.writeByte(255),t.writeByte(255),t.writeString(","),t.writeShort(0),t.writeShort(0),t.writeShort(e),t.writeShort(n),t.writeByte(0);var r=a(2);t.writeByte(2);for(var o=0;r.length-o>255;)t.writeByte(255),t.writeBytes(r,o,255),o+=255;t.writeByte(r.length-o),t.writeBytes(r,o,r.length-o),t.writeByte(0),t.writeString(";")}},a=function(t){for(var r=1<<t,e=1+(1<<t),n=t+1,i=u(),a=0;a<r;a+=1)i.add(String.fromCharCode(a));i.add(String.fromCharCode(r)),i.add(String.fromCharCode(e));var f,c,g,l=D(),h=(f=l,c=0,g=0,{write:function(t,r){if(t>>>r!=0)throw"length over";for(;c+r>=8;)f.writeByte(255&(t<<c|g)),r-=8-c,t>>>=8-c,g=0,c=0;g|=t<<c,c+=r},flush:function(){c>0&&f.writeByte(g)}});h.write(r,n);var s=0,v=String.fromCharCode(o[s]);for(s+=1;s<o.length;){var d=String.fromCharCode(o[s]);s+=1,i.contains(v+d)?v+=d:(h.write(i.indexOf(v),n),i.size()<4095&&(i.size()==1<<n&&(n+=1),i.add(v+d)),v=d)}return h.write(i.indexOf(v),n),h.write(e,n),h.flush(),l.toByteArray()},u=function(){var t={},r=0,e={add:function(n){if(e.contains(n))throw"dup key:"+n;t[n]=r,r+=1},size:function(){return r},indexOf:function(r){return t[r]},contains:function(r){return void 0!==t[r]}};return e};return i}(t,r),o=0;o<r;o+=1)for(var i=0;i<t;i+=1)n.setPixel(i,o,e(i,o));var a=D();n.write(a);for(var u=function(){var t=0,r=0,e=0,n="",o={},i=function(t){n+=String.fromCharCode(a(63&t))},a=function(t){if(t<0);else{if(t<26)return 65+t;if(t<52)return t-26+97;if(t<62)return t-52+48;if(62==t)return 43;if(63==t)return 47}throw"n:"+t};return o.writeByte=function(n){for(t=t<<8|255&n,r+=8,e+=1;r>=6;)i(t>>>r-6),r-=6},o.flush=function(){if(r>0&&(i(t<<6-r),t=0,r=0),e%3!=0)for(var o=3-e%3,a=0;a<o;a+=1)n+="="},o.toString=function(){return n},o}(),f=a.toByteArray(),c=0;c<f.length;c+=1)u.writeByte(f[c]);return u.flush(),"data:image/gif;base64,"+u};return t}();qrcode.stringToBytesFuncs["UTF-8"]=function(t){return function(t){for(var r=[],e=0;e<t.length;e++){var n=t.charCodeAt(e);n<128?r.push(n):n<2048?r.push(192|n>>6,128|63&n):n<55296||n>=57344?r.push(224|n>>12,128|n>>6&63,128|63&n):(e++,n=65536+((1023&n)<<10|1023&t.charCodeAt(e)),r.push(240|n>>18,128|n>>12&63,128|n>>6&63,128|63&n))}return r}(t)},function(t){"function"==typeof define&&define.amd?define([],t):"object"==typeof exports&&(module.exports=t())}(function(){return qrcode});
function initializeGenerator(root){
  const prefix=root.id+'-';
  const tr=JSON.parse(root.querySelector('[data-qr-i18n]').textContent);
  const enabledTypes=new Set(root.dataset.enabledTypes.split(',').filter(Boolean));
  adaptToTheme(root);

    const ICONS={qr:'<rect x="3" y="3" width="6" height="6" rx="1"/><rect x="15" y="3" width="6" height="6" rx="1"/><rect x="3" y="15" width="6" height="6" rx="1"/><path d="M15 15h3v3h3v3h-6v-3M12 3v6M3 12h6M12 12h3M21 12v3M12 18v3"/>',link:'<path d="M10 13a5 5 0 007 .1l3-3a5 5 0 00-7-7l-2 2M14 11a5 5 0 00-7-.1l-3 3a5 5 0 007 7l2-2"/>',pdf:'<path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6M8 13h8M8 17h5"/>',whatsapp:'<path d="M20.5 11.5a8.5 8.5 0 01-12.7 7.4L3 20l1.1-4.8A8.5 8.5 0 1120.5 11.5z"/><path d="M8.3 7.2c-.5.4-.6 1.3-.2 2.5a9.2 9.2 0 005.6 5.5c1.2.4 2.1.2 2.5-.4l.4-1.2-2.6-1.2-.8 1c-1.5-.6-2.6-1.6-3.2-3.1l.9-.8L9.8 7z"/>',image:'<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8" cy="8" r="2"/><path d="M21 15l-5-5L5 21"/>',contact:'<rect x="4" y="2" width="16" height="20" rx="2"/><circle cx="12" cy="8" r="2"/><path d="M8 15v-1a4 4 0 018 0v1M4 18h16"/>',social:'<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.6 10.5l6.8-4M8.6 13.5l6.8 4"/>',wifi:'<path d="M2 8a16 16 0 0120 0M5 12a11 11 0 0114 0M8.5 16a5.5 5.5 0 017 0"/><circle cx="12" cy="20" r=".6"/>',video:'<rect x="2" y="5" width="14" height="14" rx="2"/><path d="M16 9l6-4v14l-6-4z"/>',location:'<path d="M19 9c0 5-7 11-7 11S5 14 5 9a7 7 0 0114 0z"/><circle cx="12" cy="9" r="2.5"/>',email:'<rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 6l10 7L22 6"/>',feedback:'<path d="M21 11a9 9 0 01-13.7 7.7L2 21l1.9-5.4A9 9 0 1121 11z"/><path d="M12 14l-3.4-3.3a2.2 2.2 0 013.4-2.8 2.2 2.2 0 013.4 2.8z"/>',app:'<rect x="6" y="2" width="12" height="20" rx="2"/><path d="M10 5h4M11.9 19h.2"/>',links:'<rect x="3" y="3" width="5" height="5" rx="1"/><rect x="3" y="11" width="5" height="5" rx="1"/><path d="M12 4h9M12 8h6M12 12h9M12 16h6M3 21h18"/>',sms:'<path d="M21 15a2 2 0 01-2 2H8l-5 5V4a2 2 0 012-2h14a2 2 0 012 2zM7 7h7M7 11h10"/>',payment:'<rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 9h20M6 15h4"/>',text:'<path d="M4 4h16M12 4v16M8 20h8M4 7V4M20 7V4"/>',download:'<path d="M12 3v12m-4-4l4 4 4-4M4 16v4a1 1 0 001 1h14a1 1 0 001-1v-4"/>',shield:'<path d="M12 2l8 3v6c0 5-8 11-8 11S4 16 4 11V5zM8 11l3 3 5-5"/>'};
    const icon=name=>`<svg class="qrs-icon" viewBox="0 0 24 24" aria-hidden="true">${ICONS[name]||ICONS.link}</svg>`;
    const $=id=>root.querySelector(`[data-qr-id="${id}"]`);
    root.querySelectorAll('[data-icon]').forEach(el=>el.innerHTML=icon(el.dataset.icon));
    const field=(id,label,options={})=>({id,label,...options});
    const linkField=(label,placeholder)=>[field('url',label,{required:true,placeholder:placeholder||'https://esempio.it',inputmode:'url'})];
    const TYPES=[
      {id:'website',title:tr.sito_web,description:tr.apri_un_sito_web_o_una_landing_page,icon:'link',color:'purple',heading:tr.inserisci_il_link_del_tuo_sito,fields:linkField(tr.indirizzo_del_sito_web),popular:true},
      {id:'pdf',title:tr.pdf,description:tr.apri_un_documento_pdf,icon:'pdf',color:'pink',heading:tr.collega_il_tuo_documento_pdf,notice:tr.incolla_il_link_pubblico_del_pdf_gia_online_il_documento_deve_es,fields:linkField(tr.link_al_documento_pdf,'https://esempio.it/documento.pdf')},
      {id:'whatsapp',title:tr.whatsapp,description:tr.avvia_una_chat_whatsapp_all_istante,icon:'whatsapp',color:'green',heading:tr.inserisci_il_tuo_numero_whatsapp,fields:[field('phone',tr.numero_whatsapp,{kind:'phone',required:true,placeholder:'333 123 4567'}),field('message',tr.messaggio_precompilato,{kind:'textarea',placeholder:tr.ciao_vorrei_avere_maggiori_informazioni,max:1500})]},
      {id:'image',title:tr.immagine,description:tr.mostra_un_immagine_o_una_foto,icon:'image',color:'orange',heading:tr.collega_la_tua_immagine,notice:tr.usa_il_link_pubblico_di_un_immagine_gia_online_un_file_presente_,fields:linkField(tr.link_all_immagine,'https://esempio.it/immagine.jpg')},
      {id:'vcard',title:'vCard',description:tr.condividi_un_biglietto_da_visita_digitale,icon:'contact',color:'pink',heading:tr.crea_il_tuo_biglietto_da_visita,fields:[field('first',tr.nome,{required:true,placeholder:tr.mario,max:80}),field('last',tr.cognome,{placeholder:tr.rossi,max:80}),field('company',tr.azienda_o_attivita,{placeholder:tr.nome_della_tua_attivita,max:120}),field('role',tr.ruolo,{placeholder:tr.il_tuo_ruolo,max:100}),field('phone',tr.telefono,{kind:'phone',placeholder:'333 123 4567'}),field('email',tr.email,{type:'email',placeholder:'nome@esempio.it',max:160}),field('url',tr.sito_web,{placeholder:'https://esempio.it',inputmode:'url'}),field('address',tr.indirizzo,{placeholder:tr.via_numero_citta_cap,max:250})]},
      {id:'social',title:tr.social_media,description:tr.condividi_il_tuo_profilo_social,icon:'social',color:'purple',heading:tr.condividi_il_tuo_profilo,fields:linkField(tr.link_al_profilo_social,'https://www.instagram.com/tuoprofilo')},
      {id:'wifi',title:tr.wi_fi,description:tr.connettiti_a_una_rete_wi_fi,icon:'wifi',color:'green',heading:tr.inserisci_i_dati_della_rete_wi_fi,fields:[field('ssid',tr.nome_della_rete_ssid,{required:true,placeholder:tr.il_nome_esatto_della_rete,max:32}),field('encryption',tr.sicurezza,{kind:'select',options:[['WPA',tr.wpa_wpa2_personal],['WEP','WEP'],['nopass',tr.rete_aperta_senza_password]],default:'WPA'}),field('password',tr.password_della_rete,{type:'password',placeholder:tr.password_wi_fi,max:128}),field('hidden',tr.rete_nascosta,{kind:'checkbox'})]},
      {id:'video',title:tr.video,description:tr.mostra_un_video_con_una_scansione,icon:'video',color:'pink',heading:tr.collega_il_tuo_video,notice:tr.incolla_un_link_pubblico_per_esempio_un_video_su_youtube_o_vimeo,fields:linkField(tr.link_al_video,'https://www.youtube.com/watch?v=…')},
      {id:'location',title:tr.posizione,description:tr.apri_una_posizione_in_google_maps,icon:'location',color:'purple',heading:tr.scegli_una_posizione,fields:[field('address',tr.indirizzo_o_luogo,{required:true,placeholder:tr.via_radici_in_piano_9_castellarano_re,max:300,help:tr.puoi_inserire_anche_coordinate_per_esempio_44_513_10_735})]},
      {id:'email',title:tr.email,description:tr.apri_un_email_precompilata,icon:'email',color:'green',heading:tr.prepara_il_messaggio_email,fields:[field('email',tr.indirizzo_email_del_destinatario,{required:true,type:'email',placeholder:'nome@esempio.it',max:160}),field('subject',tr.oggetto,{placeholder:tr.richiesta_informazioni,max:180}),field('message',tr.messaggio,{kind:'textarea',placeholder:tr.buongiorno_vorrei,max:1500})]},
      {id:'feedback',title:tr.feedback,description:tr.richiedi_un_feedback_o_una_recensione,icon:'feedback',color:'orange',heading:tr.condividi_il_link_per_le_recensioni,fields:linkField(tr.link_alle_recensioni_o_al_modulo_feedback,'https://…')},
      {id:'app',title:tr.link_app,description:tr.apri_la_pagina_di_un_app,icon:'app',color:'pink',heading:tr.collega_la_tua_app,notice:tr.usa_un_link_all_app_store_a_google_play_o_una_pagina_gia_esisten,fields:linkField(tr.link_all_app_o_alla_pagina_di_download,'https://apps.apple.com/…')},
      {id:'links',title:tr.piu_link,description:tr.apri_una_pagina_che_raccoglie_i_tuoi_link,icon:'links',color:'purple',heading:tr.collega_la_tua_pagina_con_piu_link,notice:tr.incolla_l_url_di_una_pagina_gia_online_che_raccoglie_i_tuoi_link,fields:linkField(tr.link_alla_pagina_con_i_tuoi_collegamenti,'https://linktr.ee/tuoprofilo')},
      {id:'sms',title:tr.sms,description:tr.apri_un_sms_precompilato,icon:'sms',color:'green',heading:tr.prepara_il_tuo_sms,fields:[field('phone',tr.numero_di_telefono,{kind:'phone',required:true,placeholder:'333 123 4567'}),field('message',tr.messaggio,{kind:'textarea',placeholder:tr.ciao_vorrei,max:1500})]},
      {id:'payment',title:tr.pagamento,description:tr.apri_un_link_per_ricevere_pagamenti,icon:'payment',color:'orange',heading:tr.collega_la_tua_pagina_di_pagamento,notice:tr.incolla_un_link_di_pagamento_gia_creato_per_esempio_con_paypal_o,fields:linkField(tr.link_di_pagamento,'https://paypal.me/…')},
      {id:'text',title:tr.testo,description:tr.condividi_un_messaggio_o_un_informazione,icon:'text',color:'purple',heading:tr.scrivi_il_contenuto_del_qr,fields:[field('text',tr.testo_da_condividere,{kind:'textarea',required:true,placeholder:tr.scrivi_il_tuo_messaggio,max:2200})]}
    ];
    const state={type:null,step:1,drafts:{},qr:null,payload:'',valid:false,colorsValid:true};
    const escapeHTML=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    qrcode.stringToBytes=s=>Array.from(new TextEncoder().encode(s));
    $('types-grid').innerHTML=TYPES.filter(t=>enabledTypes.has(t.id)).map(t=>`<button class="qrs-type-card" type="button" data-type="${t.id}"><span class="qrs-${t.color}">${icon(t.icon)}</span><span class="qrs-type-copy"><span class="qrs-type-title">${escapeHTML(t.title)}</span><span class="qrs-type-description">${escapeHTML(t.description)}</span></span>${t.popular?'<span class="qrs-popular">'+escapeHTML(tr.piu_usati)+'</span>':''}</button>`).join('');
    if(!enabledTypes.size){$('types-grid').textContent=tr.no_types;}
    const COUNTRIES=[['+39','IT +39'],['+33','FR +33'],['+49','DE +49'],['+34','ES +34'],['+41','CH +41'],['+44','UK +44'],['+1','US +1']];
    function renderField(f){
      const key='f-'+f.id,id=prefix+key,required=f.required?' required':'',placeholder=f.placeholder?` placeholder="${escapeHTML(f.placeholder)}"`:'';
      const attrs=`data-qr-id="${key}" id="${id}" name="${f.id}"${required}${placeholder} aria-describedby="${id}-help ${id}-error"${f.max?` maxlength="${f.max}"`:''}${f.inputmode?` inputmode="${f.inputmode}"`:''}`;
      let input;
      if(f.kind==='checkbox')return `<div class="qrs-field" id="${prefix}wrap-${f.id}" data-qr-id="wrap-${f.id}"><label class="qrs-check-label"><input type="checkbox" id="${id}" data-qr-id="${key}" name="${f.id}">${escapeHTML(f.label)}</label></div>`;
      if(f.kind==='textarea')input=`<textarea ${attrs} rows="4"></textarea>`;
      else if(f.kind==='select')input=`<select ${attrs}>${f.options.map(([v,l])=>`<option value="${v}">${escapeHTML(l)}</option>`).join('')}</select>`;
      else if(f.kind==='phone')input=`<div class="qrs-phone-field"><select id="${prefix}f-country" data-qr-id="f-country" aria-label="${escapeHTML(tr.prefisso_internazionale)}">${COUNTRIES.map(([v,l])=>`<option value="${v}">${escapeHTML(l)}</option>`).join('')}</select><input ${attrs} type="tel" inputmode="tel" autocomplete="tel-national"></div>`;
      else input=`<input ${attrs} type="${f.type||'text'}" autocomplete="off">`;
      return `<div class="qrs-field" id="${prefix}wrap-${f.id}" data-qr-id="wrap-${f.id}"><label class="qrs-field-label" for="${id}">${escapeHTML(f.label)}${f.required?'<span class="qrs-required">*</span>':''}</label>${input}<small id="${id}-help">${escapeHTML(f.help||(f.kind==='phone'?tr.se_il_numero_inizia_con_o_00_viene_usato_il_prefisso_inserito:''))}</small><div class="qrs-field-error" id="${id}-error" data-qr-id="${key}-error" hidden></div></div>`;
    }
    function getData(){const d={};if(!state.type)return d;for(const f of state.type.fields){d[f.id]=f.kind==='checkbox'?$('f-'+f.id).checked:$('f-'+f.id).value;}if($('f-country'))d.country=$('f-country').value;d.name=$('qr-name').value;return d;}
    function saveDraft(){if(state.type)state.drafts[state.type.id]=getData();}
    function selectType(id){
      saveDraft();state.type=TYPES.find(t=>t.id===id);state.qr=null;state.payload='';state.valid=false;
      $('editor-title').textContent=state.type.title;$('selected-icon').className='qrs-type-chip qrs-'+state.type.color;$('selected-icon').innerHTML=icon(state.type.icon);$('form-title').textContent=state.type.heading;
      $('type-notice').hidden=!state.type.notice;$('type-notice').textContent=state.type.notice||'';
      $('dynamic-fields').innerHTML=state.type.fields.map(renderField).join('');
      const saved=state.drafts[id]||{};
      for(const f of state.type.fields){if(f.kind==='checkbox')$('f-'+f.id).checked=!!saved[f.id];else $('f-'+f.id).value=saved[f.id]??f.default??'';}
      if($('f-country'))$('f-country').value=saved.country||'+39';
      $('qr-name').value=saved.name??tr.il_mio_qr+' '+state.type.title;
      $('form-error').hidden=true;$('custom-error').hidden=true;$('download-status').hidden=true;$('payload-details').open=false;
      conditionalFields();setStep(2);updatePreview();
    }
    function setStep(n){
      if(n>1&&!state.type)return;if(n===3&&!state.valid)return;
      if(n===1)saveDraft();state.step=n;$('choose').hidden=n!==1;$('editor').hidden=n===1;$('content-form').hidden=n!==2;$('customize').hidden=n!==3;
      for(let i=1;i<=3;i++){const b=$('step-'+i);b.classList.toggle('qrs-active',i===n);b.classList.toggle('qrs-complete',i<n);b.disabled=i===1?false:i===2?!state.type:!state.valid;if(i===n)b.setAttribute('aria-current','step');else b.removeAttribute('aria-current');}
      root.querySelector('.qrs-steps').scrollIntoView({block:'start',behavior:'instant'});(n===1?$('choose-title'):n===3?$('customize-title'):$('editor-title')).focus({preventScroll:true});
    }
    function conditionalFields(){if(state.type.id==='wifi'){const open=$('f-encryption').value==='nopass';$('wrap-password').hidden=open;$('f-password').disabled=open;$('f-password').required=!open;}}
    class FieldError extends Error{constructor(field,message){super(message);this.field=field;}}
    function fail(field,message){throw new FieldError(field,message);}
    function normalizeURL(raw,fieldId='url'){
      const s=raw.trim();if(!s)fail(fieldId,tr.inserisci_un_link);
      if(/\s/.test(s))fail(fieldId,tr.il_link_non_puo_contenere_spazi);
      let u;try{u=new URL(/^[a-z][a-z\d+.-]*:/i.test(s)?s:'https://'+s);}catch{fail(fieldId,tr.inserisci_un_indirizzo_web_valido_per_esempio_https_esempio_it);}
      if(!['http:','https:'].includes(u.protocol)||!u.hostname||u.username||u.password||(!u.hostname.includes('.')&&u.hostname!=='localhost'&&!u.hostname.startsWith('[')))fail(fieldId,tr.usa_un_link_web_valido_che_inizi_con_https_o_http);
      return u.href;
    }
    function normalizePhone(raw,country){
      const s=raw.trim();if(!s)fail('phone',tr.inserisci_il_numero_di_telefono);
      if(!/^\+?[\d\s().-]+$/.test(s))fail('phone',tr.usa_solo_numeri_e_un_eventuale_prefisso_internazionale);
      let cleaned=s.replace(/[\s().-]/g,'');if(cleaned.startsWith('00'))cleaned='+'+cleaned.slice(2);if(!cleaned.startsWith('+'))cleaned=country+cleaned;
      if(!/^\+[1-9]\d{6,14}$/.test(cleaned))fail('phone',tr.inserisci_un_numero_valido_con_prefisso_internazionale_7_15_cifr);return cleaned;
    }
    function checkEmail(s){if(!/^[^\s@<>:;,]+@[^\s@<>:;,]+\.[^\s@<>:;,]+$/.test(s))fail('email',tr.inserisci_un_indirizzo_email_valido);return s;}
    const escWifi=s=>s.replace(/[\\;,:"]/g,'\\$&');
    const escVcard=s=>s.replace(/\\/g,'\\\\').replace(/\r\n|\r|\n/g,'\\n').replace(/;/g,'\\;').replace(/,/g,'\\,');
    function foldVcard(line){let result='',bytes=0;for(const ch of line){const length=new TextEncoder().encode(ch).length;if(bytes+length>75){result+='\r\n ';bytes=1;}result+=ch;bytes+=length;}return result;}
    function buildPayload(d){
      for(const f of state.type.fields){if(f.required&&f.kind!=='checkbox'&&!String(d[f.id]||'').trim())fail(f.id,tr.compila_questo_campo);}
      switch(state.type.id){
        case 'whatsapp':{const p=normalizePhone(d.phone,d.country);return 'https://wa.me/'+p.slice(1)+(d.message?'?text='+encodeURIComponent(d.message):'');}
        case 'wifi':{if(new TextEncoder().encode(d.ssid).length>32)fail('ssid',tr.il_nome_della_rete_deve_occupare_al_massimo_32_byte);if(d.encryption!=='nopass'&&!d.password)fail('password',tr.inserisci_la_password_della_rete);return 'WIFI:T:'+d.encryption+';S:'+escWifi(d.ssid)+';'+(d.encryption!=='nopass'?'P:'+escWifi(d.password)+';':'')+(d.hidden?'H:true;':'')+';';}
        case 'vcard':{const v=['BEGIN:VCARD','VERSION:3.0','N:'+escVcard(d.last)+';'+escVcard(d.first)+';;;','FN:'+escVcard([d.first,d.last].filter(Boolean).join(' '))];if(d.company)v.push('ORG:'+escVcard(d.company));if(d.role)v.push('TITLE:'+escVcard(d.role));if(d.phone.trim())v.push('TEL;TYPE=CELL:'+normalizePhone(d.phone,d.country));if(d.email.trim())v.push('EMAIL;TYPE=INTERNET:'+escVcard(checkEmail(d.email.trim())));if(d.url.trim())v.push('URL:'+escVcard(normalizeURL(d.url)));if(d.address)v.push('ADR;TYPE=WORK:;;'+escVcard(d.address)+';;;;');v.push('END:VCARD');return v.map(foldVcard).join('\r\n')+'\r\n';}
        case 'email':{const email=checkEmail(d.email.trim());const params=[];if(d.subject)params.push('subject='+encodeURIComponent(d.subject));if(d.message)params.push('body='+encodeURIComponent(d.message));return 'mailto:'+encodeURIComponent(email).replace('%40','@')+(params.length?'?'+params.join('&'):'');}
        case 'sms':return 'SMSTO:'+normalizePhone(d.phone,d.country)+':'+d.message;
        case 'location':return 'https://www.google.com/maps/search/?api=1&query='+encodeURIComponent(d.address.trim());
        case 'text':return d.text;
        default:return normalizeURL(d.url);
      }
    }
    function makeQR(payload){const qr=qrcode(0,$('correction').value);qr.addData(payload,'Byte');qr.make();return qr;}
    function svgString(qr){const count=qr.getModuleCount(),side=count+8;let path='';for(let y=0;y<count;y++)for(let x=0;x<count;x++)if(qr.isDark(y,x))path+=`M${x+4} ${y+4}h1v1h-1z`;return `<svg xmlns="http://www.w3.org/2000/svg" width="${$('size').value}" height="${$('size').value}" viewBox="0 0 ${side} ${side}" shape-rendering="crispEdges" role="img" aria-label="${escapeHTML(tr.codice_qr)}"><rect width="${side}" height="${side}" fill="${$('background').value}"/><path fill="${$('foreground').value}" d="${path}"/></svg>`;}
    function luminance(hex){const rgb=hex.slice(1).match(/../g).map(x=>parseInt(x,16)/255).map(v=>v<=.04045?v/12.92:((v+.055)/1.055)**2.4);return .2126*rgb[0]+.7152*rgb[1]+.0722*rgb[2];}
    function checkColors(){const fg=luminance($('foreground').value),bg=luminance($('background').value),ratio=(bg+.05)/(fg+.05);state.colorsValid=bg>fg&&ratio>=4.5;$('quality-note').classList.toggle('qrs-warning',!state.colorsValid);$('quality-note').textContent=state.colorsValid?tr.contrasto_adatto_alla_scansione_il_margine_libero_viene_mantenut:tr.scegli_un_qr_piu_scuro_e_uno_sfondo_piu_chiaro_aumenta_il_contra;['foreground','background'].forEach(id=>$(id+'-value').textContent=$(id).value.toUpperCase());}
    function clearErrors(){root.querySelectorAll('.qrs-field-error').forEach(e=>{e.hidden=true;e.textContent='';});root.querySelectorAll('[aria-invalid]').forEach(e=>e.removeAttribute('aria-invalid'));$('form-error').hidden=true;}
    function displayError(error){if(error.field&&$('f-'+error.field)){$('f-'+error.field).setAttribute('aria-invalid','true');const e=$('f-'+error.field+'-error');if(e){e.textContent=error.message;e.hidden=false;}$('f-'+error.field).focus();}else{$('form-error').textContent=error.message;$('form-error').hidden=false;}}
    function updatePreview(showErrors=false){
      if(!state.type)return;checkColors();clearErrors();$('download-status').hidden=true;$('custom-error').hidden=true;
      const d=getData();$('preview-title').textContent=d.name.trim()||state.type.title;$('whatsapp-preview').hidden=state.type.id!=='whatsapp';
      if(state.type.id==='whatsapp'){try{$('wa-number').textContent=normalizePhone(d.phone,d.country);}catch{$('wa-number').textContent=tr.whatsapp;}$('wa-message').textContent=d.message||tr.il_tuo_messaggio_apparira_qui;}
      let error;try{state.payload=buildPayload(d);try{state.qr=makeQR(state.payload);}catch{throw new Error(tr.il_contenuto_e_troppo_lungo_per_un_qr_con_questa_correzione_ridu);}state.valid=true;}catch(e){state.valid=false;state.qr=null;state.payload='';error=e;}
      if(state.valid){$('qr-frame').innerHTML=svgString(state.qr);$('preview-meta').textContent='QR '+state.type.title+' · '+state.qr.getModuleCount()+' × '+state.qr.getModuleCount()+' '+tr.moduli;$('preview-hint').textContent=tr.provalo_con_la_fotocamera_prima_di_stamparlo;$('payload-text').textContent=state.payload;$('payload-details').hidden=false;}
      else{$('qr-frame').innerHTML=`<div class="qrs-qr-placeholder">${icon('qr')}<span>${escapeHTML(tr.il_tuo_qr_apparira_qui)}</span></div>`;$('preview-meta').textContent=error instanceof FieldError?tr.in_attesa_dei_dati:tr.contenuto_troppo_lungo;$('preview-hint').textContent=error instanceof FieldError?tr.compila_i_dati_per_vedere_il_tuo_codice_qr:error.message;$('payload-text').textContent='';$('payload-details').hidden=true;if(showErrors)displayError(error);}
      if(!state.valid&&state.step===3){$('custom-error').hidden=false;$('custom-error').textContent=error.message;}
      $('download-png').disabled=$('download-svg').disabled=!state.valid||!state.colorsValid;$('step-3').disabled=!state.valid;return state.valid;
    }
    function filename(){return ($('qr-name').value.trim()||'qr-'+state.type.id).normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-zA-Z0-9_-]+/g,'-').replace(/^-+|-+$/g,'').slice(0,80)||'codice-qr';}
    function saveBlob(blob,name){const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=name;document.body.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),60000);}
    function exportCanvas(){const size=Number($('size').value),qr=state.qr,count=qr.getModuleCount(),side=count+8,canvas=document.createElement('canvas');canvas.width=canvas.height=size;const ctx=canvas.getContext('2d');ctx.fillStyle=$('background').value;ctx.fillRect(0,0,size,size);ctx.fillStyle=$('foreground').value;for(let y=0;y<count;y++)for(let x=0;x<count;x++)if(qr.isDark(y,x)){const left=Math.round((x+4)*size/side),top=Math.round((y+4)*size/side);ctx.fillRect(left,top,Math.round((x+5)*size/side)-left,Math.round((y+5)*size/side)-top);}return canvas;}
    async function download(format){
      if(!updatePreview(true)||!state.colorsValid)return;
      try{let blob;if(format==='svg')blob=new Blob(['<?xml version="1.0" encoding="UTF-8"?>\n'+svgString(state.qr)],{type:'image/svg+xml;charset=utf-8'});else blob=await new Promise((resolve,reject)=>exportCanvas().toBlob(b=>b?resolve(b):reject(new Error(tr.impossibile_creare_il_png)),'image/png'));saveBlob(blob,filename()+'.'+format);$('download-status').textContent=tr.file+' '+format.toUpperCase()+' '+tr.pronto_controlla_i_download_del_browser;$('download-status').hidden=false;}catch(e){$('custom-error').textContent=tr.download_non_riuscito_riprova_oppure_scegli_l_altro_formato;$('custom-error').hidden=false;}
    }
    $('types-grid').addEventListener('click',e=>{const button=e.target.closest('[data-type]');if(button)selectType(button.dataset.type);});
    $('content-form').addEventListener('input',()=>{conditionalFields();updatePreview();});$('content-form').addEventListener('change',()=>{conditionalFields();updatePreview();});
    $('content-form').addEventListener('submit',e=>{e.preventDefault();if(updatePreview(true)){saveDraft();setStep(3);}});
    ['foreground','background','size','correction'].forEach(id=>$(id).addEventListener('input',()=>updatePreview()));
    root.querySelectorAll('[data-color]').forEach(b=>b.addEventListener('click',()=>{$('foreground').value=b.dataset.color;updatePreview();}));
    ['change-type','back-types','new-qr','step-1'].forEach(id=>$(id).addEventListener('click',()=>setStep(1)));
    ['back-content','step-2'].forEach(id=>$(id).addEventListener('click',()=>setStep(2)));$('step-3').addEventListener('click',()=>{if(updatePreview(true))setStep(3);});
    $('download-svg').addEventListener('click',()=>download('svg'));$('download-png').addEventListener('click',()=>download('png'));
  
}
function adaptToTheme(root){
  if(root.dataset.inheritTheme!=='true')return;
  const bodyStyle=getComputedStyle(document.body);
  const heading=Array.from(document.querySelectorAll('h1,h2')).find(el=>!el.closest('qr-studio-generator'));
  const headingStyle=heading?getComputedStyle(heading):bodyStyle;
  if(bodyStyle.fontFamily)root.style.setProperty('--qrs-body-font',bodyStyle.fontFamily);
  const headingFont=bodyStyle.getPropertyValue('--font-heading-family').trim()||headingStyle.fontFamily;
  if(headingFont)root.style.setProperty('--qrs-heading-font',headingFont);
  const page=document.querySelector('#MainContent,main')||document.body;
  const pageStyle=getComputedStyle(page);
  const opaque=color=>color&&color!=='transparent'&&color!=='rgba(0, 0, 0, 0)'&&!/[,/]\s*0\s*\)$/.test(color);
  const tokenColor=token=>{const value=token.trim();if(/^\d+(?:\s*,\s*|\s+)\d+(?:\s*,\s*|\s+)\d+$/.test(value))return 'rgb('+value+')';return value;};
  const ink=tokenColor(pageStyle.getPropertyValue('--color-foreground'))||pageStyle.color||bodyStyle.color;
  if(ink)root.style.setProperty('--qrs-ink',ink);
  let background=tokenColor(pageStyle.getPropertyValue('--color-background'));
  for(let el=page;!background&&el;el=el.parentElement){const value=getComputedStyle(el).backgroundColor;if(opaque(value))background=value;}
  if(background){root.style.setProperty('--qrs-background',background);root.style.setProperty('--qrs-surface','color-mix(in srgb, '+background+' 97%, '+(ink||'#17191e')+' 3%)');}
  const selector='.button--primary,.btn--primary,.product-form__submit,.shopify-payment-button__button--unbranded,button[name="add"],a.button,a.btn,button.button,button.btn';
  const button=Array.from(document.querySelectorAll(selector)).find(el=>!el.closest('qr-studio-generator')&&opaque(getComputedStyle(el).backgroundColor));
  if(button){const style=getComputedStyle(button);root.style.setProperty('--qrs-accent',style.backgroundColor);root.style.setProperty('--qrs-button-text',style.color);root.style.setProperty('--qrs-button-radius',style.borderTopLeftRadius||style.borderRadius||'10px');}
  else{const accent=tokenColor(pageStyle.getPropertyValue('--color-button')||bodyStyle.getPropertyValue('--color-button'));const text=tokenColor(pageStyle.getPropertyValue('--color-button-text')||bodyStyle.getPropertyValue('--color-button-text'));if(accent)root.style.setProperty('--qrs-accent',accent);if(text)root.style.setProperty('--qrs-button-text',text);}
  const field=Array.from(document.querySelectorAll('input[type="email"],input[type="search"],input[type="text"]')).find(el=>!el.closest('qr-studio-generator'));
  if(field)root.style.setProperty('--qrs-input-radius',getComputedStyle(field).borderTopLeftRadius||getComputedStyle(field).borderRadius||'10px');
}
if(!customElements.get('qr-studio-generator')){
  customElements.define('qr-studio-generator',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      if(!this.querySelector('[data-qr-app]')){this.pending=requestAnimationFrame(()=>this.connectedCallback());return;}
      this.initialized=true;
      initializeGenerator(this);
    }
    disconnectedCallback(){if(this.pending)cancelAnimationFrame(this.pending);}
  });
}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopper-personalizzata"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('m3-shopper')) {
class M3ShopperViewer {
  constructor(canvas, overlay, onFailure) {
    this.canvas=canvas;this.overlay=overlay;this.onFailure=onFailure;this.yaw=-.52;this.pitch=.36;this.zoom=1;this.axes=true;this.raf=0;this.pointers=new Map();this.abort=new AbortController();
    this.gl=canvas.getContext('webgl',{alpha:true,antialias:true});
    if(!this.gl)throw new Error('webgl');
    this.init();
    const signal=this.abort.signal,on=(type,fn,options={})=>canvas.addEventListener(type,fn,{...options,signal});
    on('pointerdown',e=>{if(e.button!==0)return;canvas.setPointerCapture(e.pointerId);this.pointers.set(e.pointerId,[e.clientX,e.clientY]);});
    on('pointermove',e=>{const p=this.pointers.get(e.pointerId);if(!p)return;
      if(this.pointers.size===2){const other=[...this.pointers.entries()].find(([id])=>id!==e.pointerId)[1],before=Math.hypot(p[0]-other[0],p[1]-other[1]),after=Math.hypot(e.clientX-other[0],e.clientY-other[1]);if(before>2)this.zoom=this.clamp(this.zoom*after/before,.5,2.5);}
      else{this.yaw+=(e.clientX-p[0])*.009;this.pitch=this.clamp(this.pitch+(e.clientY-p[1])*.008,-.95,1.2);}
      this.pointers.set(e.pointerId,[e.clientX,e.clientY]);this.draw();
    });
    ['pointerup','pointercancel','lostpointercapture'].forEach(type=>on(type,e=>this.pointers.delete(e.pointerId)));
    on('wheel',e=>{e.preventDefault();this.zoomBy(Math.exp(-e.deltaY*.001));},{passive:false});
    on('keydown',e=>{let used=true;switch(e.key){case 'ArrowLeft':this.yaw-=.1;break;case 'ArrowRight':this.yaw+=.1;break;case 'ArrowUp':this.pitch=this.clamp(this.pitch+.1,-.95,1.2);break;case 'ArrowDown':this.pitch=this.clamp(this.pitch-.1,-.95,1.2);break;case '+':case '=':this.zoomBy(1.15);break;case '-':this.zoomBy(1/1.15);break;case 'Home':this.reset();break;default:used=false;}if(used){e.preventDefault();this.draw();}});
    on('webglcontextlost',e=>{e.preventDefault();this.lost=true;this.onFailure();});
    on('webglcontextrestored',()=>{this.lost=false;this.init();if(this.data)this.set(this.data);});
    this.observer=new ResizeObserver(()=>this.draw());this.observer.observe(canvas);
  }
  clamp(n,a,b){return Math.max(a,Math.min(b,n));}
  init(){
    const gl=this.gl,shader=(type,src)=>{const sh=gl.createShader(type);gl.shaderSource(sh,src);gl.compileShader(sh);if(!gl.getShaderParameter(sh,gl.COMPILE_STATUS))throw new Error(gl.getShaderInfoLog(sh));return sh;};
    const vs=shader(gl.VERTEX_SHADER,'attribute vec3 aPosition;attribute vec4 aColor;attribute vec3 aPaper;varying vec4 vColor;varying vec3 vPaper;void main(){gl_Position=vec4(aPosition,1.0);vColor=aColor;vPaper=aPaper;}');
    const fs=shader(gl.FRAGMENT_SHADER,'precision mediump float;varying vec4 vColor;varying vec3 vPaper;float grain(vec2 p){vec3 q=fract(vec3(p.xyx)*.1031);q+=dot(q,q.yzx+33.33);return fract((q.x+q.y)*q.z);}void main(){float g=(grain(floor(mod(vPaper.xy*5.0,256.0)))-.5)*vPaper.z;gl_FragColor=vec4(clamp(vColor.rgb+g,0.0,1.0),vColor.a);}');
    this.program=gl.createProgram();gl.attachShader(this.program,vs);gl.attachShader(this.program,fs);gl.linkProgram(this.program);gl.deleteShader(vs);gl.deleteShader(fs);if(!gl.getProgramParameter(this.program,gl.LINK_STATUS))throw new Error(gl.getProgramInfoLog(this.program));
    this.buffer=gl.createBuffer();this.attrs=['aPosition','aColor','aPaper'].map(name=>gl.getAttribLocation(this.program,name));gl.enable(gl.DEPTH_TEST);gl.depthFunc(gl.LEQUAL);gl.disable(gl.CULL_FACE);gl.enable(gl.BLEND);gl.blendFunc(gl.SRC_ALPHA,gl.ONE_MINUS_SRC_ALPHA);
  }
  set(data){
    this.data=data;const {w,s,h,r}=data.dims;this.W=w*10;this.D=s*10;this.H=h*10;this.R=Math.min(r*10,this.H*.3);this.handleH=Math.min(95,Math.max(70,this.W*.3));this.faces=[];
    const W=this.W/2,D=this.D/2,H=this.H,t=.65,bottom=-H/2,top=H/2,front=D,back=-D;
    const quad=(points,color,grain=.022)=>this.faces.push({points,color,grain});
    const paper=data.paper==='usomano'?[.94,.927,.887]:[.973,.970,.950],inside=paper.map(v=>v*.78);
    const grain=data.paper==='usomano'?.04:.014;
    quad([[-W,bottom,front],[W,bottom,front],[W,top,front],[-W,top,front]],paper,grain);
    quad([[W,bottom,back],[-W,bottom,back],[-W,top,back],[W,top,back]],paper,grain);
    quad([[-W+t,top,front-t],[W-t,top,front-t],[W-t,bottom+t,front-t],[-W+t,bottom+t,front-t]],inside,grain);
    quad([[W-t,top,back+t],[-W+t,top,back+t],[-W+t,bottom+t,back+t],[W-t,bottom+t,back+t]],inside,grain);
    for(const side of [-1,1]){
      const x=side*W,inset=side*(W-Math.min(8,this.D*.08)),q1=[[x,bottom,back],[inset,bottom,0],[inset,top,0],[x,top,back]],q2=[[inset,bottom,0],[x,bottom,front],[x,top,front],[inset,top,0]];
      quad(side===1?q1:q1.slice().reverse(),paper.map(v=>v*.97),grain);quad(side===1?q2:q2.slice().reverse(),paper,grain);
      for(const q of [q1,q2])quad(q.map(p=>[p[0]-side*t,p[1],p[2]]).reverse(),inside,grain);
      quad([[x,top,back],[inset,top,0],[inset-side*t,top,0],[x-side*t,top,back]],paper,grain);
      quad([[inset,top,0],[x,top,front],[x-side*t,top,front],[inset-side*t,top,0]],paper,grain);
    }
    quad([[-W,bottom,back],[W,bottom,back],[W,bottom,front],[-W,bottom,front]],inside,grain);
    quad([[-W+t,bottom+t,front-t],[W-t,bottom+t,front-t],[W-t,bottom+t,back+t],[-W+t,bottom+t,back+t]],inside,grain);
    for(const z of [-D,D]){
      const side=Math.sign(z),zi=z-side*1.1;
      quad([[-W+t,top-this.R,zi],[W-t,top-this.R,zi],[W-t,top,zi],[-W+t,top,zi]],paper.map(v=>v*.80),grain);
      quad([[-W,top,z],[W,top,z],[W,top,zi],[-W,top,zi]],paper,grain);
      const points=[],half=Math.min(this.W*.26,63),ropeZ=z+side*2.5;
      for(let i=0;i<=48;i++){const a=Math.PI*i/48;points.push([-half*Math.cos(a),top-15+this.handleH*Math.sin(a),ropeZ+side*Math.sin(a)*12]);}
      this.tube(points,2.5,[.22,.23,.235]);
      for(const x of [-half,half])this.tube([[x,top-22,ropeZ],[x,top-10,ropeZ]],3.2,[.19,.20,.21]);
    }
    this.draw();
  }
  tube(points,r,color){
    const rings=points.map((p,i)=>{const a=points[Math.max(0,i-1)],b=points[Math.min(points.length-1,i+1)],dx=b[0]-a[0],dy=b[1]-a[1],len=Math.hypot(dx,dy)||1;return Array.from({length:8},(_,j)=>{const t=j*Math.PI/4;return[p[0]-dy/len*Math.cos(t)*r,p[1]+dx/len*Math.cos(t)*r,p[2]+Math.sin(t)*r];});});
    for(let i=1;i<rings.length;i++)for(let j=0;j<8;j++)this.faces.push({points:[rings[i-1][j],rings[i-1][(j+1)%8],rings[i][(j+1)%8],rings[i][j]],color:color.map(v=>v+(i%3===0?.015:0)),grain:.025});
  }
  reset(){this.yaw=-.52;this.pitch=.36;this.zoom=1;this.draw();}
  zoomBy(n){this.zoom=this.clamp(this.zoom*n,.5,2.5);this.draw();}
  draw(){if(this.raf||this.lost)return;this.raf=requestAnimationFrame(()=>{this.raf=0;this.paint();});}
  paint(){
    if(!this.data||!this.canvas.isConnected||this.lost)return;
    const cv=this.canvas,w=cv.clientWidth,h=cv.clientHeight;if(!w||!h)return;
    const dpr=Math.min(devicePixelRatio||1,2);cv.width=Math.round(w*dpr);cv.height=Math.round(h*dpr);
    const ca=Math.cos(this.yaw),sa=Math.sin(this.yaw),cb=Math.cos(this.pitch),sb=Math.sin(this.pitch);
    const rotate=([x,y,z])=>{const xx=x*ca+z*sa,zz=-x*sa+z*ca;return[xx,y*cb-zz*sb,y*sb+zz*cb];};
    const scale=Math.min((w-(w<500?110:200))/Math.max(this.W+this.D*.6,140),(h-90)/(this.H+this.handleH+35))*.9*this.zoom;
    const project=p=>{const q=rotate([p[0],p[1]-this.handleH*.36,p[2]]);return[w/2+q[0]*scale,h/2-q[1]*scale,q[2]];};
    const vertices=[],depth=Math.hypot(this.W,this.H+this.handleH,this.D)*2;
    for(const face of this.faces){const p=face.points,a=p[0],b=p[1],c=p[2],u=b.map((v,i)=>v-a[i]),v=c.map((v,i)=>v-a[i]);let n=[u[1]*v[2]-u[2]*v[1],u[2]*v[0]-u[0]*v[2],u[0]*v[1]-u[1]*v[0]],len=Math.hypot(...n)||1;n=rotate(n.map(v=>v/len));
      let light=.77+Math.max(0,n[0]*-.35+n[1]*.58+n[2]*.68)*.23;if(n[2]<0)light=.72+Math.abs(n[1])*.12;
      const glossy=this.data.finish==='lucida'&&face.color[0]>.8;if(glossy)light+=Math.pow(Math.max(0,n[0]*-.25+n[1]*.25+n[2]*.935),18)*.1;
      const color=face.color.map(v=>Math.min(1,v*light));
      for(let i=1;i<p.length-1;i++)for(const point of [p[0],p[i],p[i+1]]){const s=project(point);vertices.push(s[0]/w*2-1,1-s[1]/h*2,-s[2]/depth,...color,1,point[0]+point[2],point[1],face.grain);}
    }
    const gl=this.gl;gl.viewport(0,0,cv.width,cv.height);gl.clearColor(0,0,0,0);gl.clear(gl.COLOR_BUFFER_BIT|gl.DEPTH_BUFFER_BIT);gl.useProgram(this.program);gl.bindBuffer(gl.ARRAY_BUFFER,this.buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(vertices),gl.DYNAMIC_DRAW);
    const sizes=[3,4,3],offsets=[0,12,28];this.attrs.forEach((a,i)=>{gl.enableVertexAttribArray(a);gl.vertexAttribPointer(a,sizes[i],gl.FLOAT,false,40,offsets[i]);});gl.drawArrays(gl.TRIANGLES,0,vertices.length/10);
    const shadow=cv.parentElement.querySelector('[data-shadow]'),center=project([0,-this.H/2,0]);shadow.style.cssText=`left:${center[0]}px;top:${center[1]+8}px;width:${Math.max(110,this.W*scale*1.3)}px;height:${Math.max(25,this.D*scale*.48)}px`;
    this.paintAxes(project,w,h);
  }
  paintAxes(project,w,h){
    this.overlay.toggleAttribute('hidden',!this.axes);if(!this.axes)return;
    const W=this.W/2,D=this.D/2,H=this.H/2,corners=[[-W,-H,-D],[-W,-H,D],[W,-H,-D],[W,-H,D]],center=project([0,-H,0]);
    const choose=(edges,index,sign=1)=>edges.sort((a,b)=>sign*((project(b[0])[index]+project(b[1])[index])-(project(a[0])[index]+project(a[1])[index])))[0];
    const right=corners.slice().sort((a,b)=>project(b)[0]-project(a)[0])[0];
    const edges={A:choose([[corners[0],corners[2]],[corners[1],corners[3]]],1),B:choose([[corners[0],corners[1]],[corners[2],corners[3]]],0,-1),H:[right,[right[0],H,right[2]]]};
    let content='';const color=getComputedStyle(this.canvas.closest('m3-shopper')).getPropertyValue('--m3-primary').trim()||'#1859dd';
    for(const key of ['A','B','H']){
      const p=project(edges[key][0]),q=project(edges[key][1]),dx=q[0]-p[0],dy=q[1]-p[1],len=Math.hypot(dx,dy)||1;let nx=-dy/len,ny=dx/len;
      if(nx*((p[0]+q[0])/2-center[0])+ny*((p[1]+q[1])/2-center[1])<0){nx=-nx;ny=-ny;}if(key==='H'){nx=1;ny=0;}if(key==='B'){nx=-1;ny=.15;}
      const off=w<500?20:30,a=[p[0]+nx*off,p[1]+ny*off],b=[q[0]+nx*off,q[1]+ny*off],x=this.clamp((a[0]+b[0])/2+nx*30,42,w-42),y=this.clamp((a[1]+b[1])/2+ny*23,17,h-17),val=({A:this.W,B:this.D,H:this.H}[key]/10).toLocaleString('it-IT');
      content+=`<path d="M${p[0]} ${p[1]}L${a[0]} ${a[1]}L${b[0]} ${b[1]}L${q[0]} ${q[1]} M${a[0]-3} ${a[1]-3}l6 6 M${b[0]-3} ${b[1]-3}l6 6" fill="none" stroke="${color}" stroke-opacity=".55" stroke-width="1.2"/><g transform="translate(${x},${y})"><rect x="-40" y="-14" width="80" height="28" rx="14" fill="white" fill-opacity=".94"/><text text-anchor="middle" y="4" fill="${color}" font-family="Arial,sans-serif" font-size="11"><tspan font-weight="700">${key}</tspan> ${val} cm</text></g>`;
    }
    this.overlay.setAttribute('viewBox',`0 0 ${w} ${h}`);this.overlay.innerHTML=content;
  }
  destroy(){cancelAnimationFrame(this.raf);this.abort.abort();this.observer.disconnect();this.gl.deleteBuffer(this.buffer);this.gl.deleteProgram(this.program);}
}

  customElements.define('m3-shopper', class extends HTMLElement {
    disconnectedCallback() { this.disposeViewer?.(); }
    connectedCallback() {
      if (this.initialized) { this.resumeViewer?.(); return; }
      this.initialized = true;
      const root = this;
      const CFG = JSON.parse(root.dataset.config);
      const T = JSON.parse(root.dataset.text);
      const $ = selector => root.querySelector(selector);
      const $$ = selector => [...root.querySelectorAll(selector)];
      const state = {format:'f2',paper:'monopatinata',color:'cmyk',coverage:'gte50',lamination:'opaca',cord:'cotone',qty:'q500'};
      const design = {bag_color:'#eee5d6',ink_color:'#202e29',cord_color:'#292724',text:'',logo_size:45,logo_y:42};
      let logo = '', logoBusy = false, fileVersion = 0, cartBusy = false, artworkFile = null, artworkFormat = null;
      const findById = (items, id) => items.find(item => item.id === id);
      const money = value => new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR'}).format(value);
      const esc = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&apos;'}[c]));

const quoteData = {

  
  formats: [
    { id: 'f1', name: '1) cm 12 × 11 × 40 + 5h', dims: { w:12, s:11, h:40, r:5 }, sheetW:56, sheetH:101, resa:2,   listelli:0.021, allestimento:0.110, box:'SCA29', pzImballo:200 },
    { id: 'f2', name: '2) cm 22 × 10 × 29 + 5h', dims: { w:22, s:10, h:29, r:5 }, sheetW:71, sheetH:101, resa:2,   listelli:0.025, allestimento:0.142, box:'SCA29', pzImballo:150 },
    { id: 'f3', name: '3) cm 36 × 12 × 41 + 5h', dims: { w:36, s:12, h:41, r:5 }, sheetW:56, sheetH:101, resa:1,   listelli:0.038, allestimento:0.154, box:'SCA20', pzImballo:100 },
    { id: 'f4', name: '4) cm 42 × 12 × 37 + 5h', dims: { w:42, s:12, h:37, r:5 }, sheetW:71, sheetH:101, resa:1,   listelli:0.066, allestimento:0.211, box:'SCA29', pzImballo:70  },
    { id: 'f5', name: '5) cm 24 × 10 × 20 + 5h', dims: { w:24, s:10, h:20, r:5 }, sheetW:71, sheetH:101, resa:3,   listelli:0.033, allestimento:0.142, box:'SCA29', pzImballo:150 },
    { id: 'f6', name: '6) cm 36 × 12 × 30 + 5h', dims: { w:36, s:12, h:30, r:5 }, sheetW:56, sheetH:101, resa:1,   listelli:0.043, allestimento:0.154, box:'SCA20', pzImballo:100 },
    { id: 'f7', name: '7) cm 45 × 12 × 34 + 5h', dims: { w:45, s:12, h:34, r:5 }, sheetW:71, sheetH:101, resa:1,   listelli:0.068, allestimento:0.211, box:'SCA29', pzImballo:70  },
    { id: 'f8', name: '8) cm 54 × 14 × 45 + 5h', dims: { w:54, s:14, h:45, r:5 }, sheetW:71, sheetH:101, resa:0.5, listelli:0.083, allestimento:0.235, box:'SCA03', pzImballo:50  }
  ],

  
  papers: [
    { id: 'usomano',      name: 'Usomano 185 gr',      desc: 'Carta usomano naturale',     pricePerKg: 1.39, gram: 185, inkFactor: 0.0015 },
    { id: 'monopatinata', name: 'Monopatinata 185 gr', desc: 'Carta monopatinata, resa di stampa superiore', pricePerKg: 1.39, gram: 185, inkFactor: 0.001 }
  ],

  
  colors: [
    { id: 'c1',   n: 1, name: '1 colore',      desc: 'Impianto da € 100' },
    { id: 'c2',   n: 2, name: '2 colori',      desc: 'Impianto da € 165' },
    { id: 'c3',   n: 3, name: '3 colori',      desc: 'Impianto da € 232' },
    { id: 'c4',   n: 4, name: '4 colori',      desc: 'Impianto da € 298' },
    { id: 'c5',   n: 5, name: '5 colori',      desc: 'Impianto da € 364' },
    { id: 'cmyk', n: 4, name: 'Quadricromia',  desc: 'Impianto da € 204, inchiostro incluso' }
  ],

  
  printSetup: {
    breaks: [500, 1000, 2000, 3000, 4000, 5000, 10000, 20000],
    rows: {
      'c1':   [100, 110, 129, 148, 168, 186, 284, 480],
      'c2':   [165, 176, 197, 218, 239, 260, 365, 575],
      'c3':   [232, 244, 266, 288, 310, 332, 442, 660],
      'c4':   [298, 310, 334, 357, 380, 403, 518, 750],
      'c5':   [364, 376, 402, 426, 450, 474, 594, 840],
      'cmyk': [204, 220, 248, 274, 300, 325, 450, 700]
    }
  },

  
  coverage: [
    { id: 'lt50',  name: '< 50%',  desc: 'Coprenza inchiostro inferiore al 50%', factor: 1   },
    { id: 'gte50', name: '≥ 50%',  desc: 'Alta coprenza — consumo inchiostro ×1,5', factor: 1.5 }
  ],

  
  lamination: [
    { id: 'senza',  name: 'Senza',  desc: 'Nessuna plastificazione',     rate: 0     },
    { id: 'opaca',  name: 'Opaca',  desc: '€ 0,218/mq — minimo € 90',    rate: 0.218 },
    { id: 'lucida', name: 'Lucida', desc: '€ 0,157/mq — minimo € 90',    rate: 0.157 }
  ],

  
  cords: [
    { id: 'cotone', name: 'Cotone Ø5 mm / 50 cm', desc: '€ 0,05 a busta', unitCost: 0.05 }
  ],

  
  quantities: [
    { id: 'q500',   qty: 500,   label: '500 pz',    ricarico: 55 },
    { id: 'q1000',  qty: 1000,  label: '1.000 pz',  ricarico: 50 },
    { id: 'q2000',  qty: 2000,  label: '2.000 pz',  ricarico: 45 },
    { id: 'q3000',  qty: 3000,  label: '3.000 pz',  ricarico: 40 },
    { id: 'q4000',  qty: 4000,  label: '4.000 pz',  ricarico: 32 },
    { id: 'q5000',  qty: 5000,  label: '5.000 pz',  ricarico: 32 },
    { id: 'q10000', qty: 10000, label: '10.000 pz', ricarico: 32 },
    { id: 'q20000', qty: 20000, label: '20.000 pz', ricarico: 32 }
  ],

  
  fustellatura: { 500: 0.10, 1000: 0.08, 2000: 0.06, 3000: 0.05 },
  fustellaturaDefault: 0.05,

  
  boxes: {
    'SCA29': { name: 'SCA 29', price: 0.90, perPallet: 18 },
    'SCA20': { name: 'SCA 20', price: 1.00, perPallet: 22 },
    'SCA03': { name: 'SCA 03', price: 1.10, perPallet: 18 }
  },

  
  constants: {
    waste:              1.1,   
    inkPerKg:           22,    
    laminationMin:      90,    
    palletCost:         12,    
    transportPerPallet: 50,    
    maxFogli:           20000  
  }
};



function printSetupCost(colorId, fogli) {
  const breaks = quoteData.printSetup.breaks;
  const row    = quoteData.printSetup.rows[colorId];
  if (!row) return null;
  if (fogli > quoteData.constants.maxFogli) return 'custom';
  if (fogli <= breaks[0]) return row[0];
  for (let i = 0; i < breaks.length - 1; i++) {
    if (fogli === breaks[i]) return row[i];
    if (fogli > breaks[i] && fogli < breaks[i + 1]) {
      const t = (fogli - breaks[i]) / (breaks[i + 1] - breaks[i]);
      return row[i] + t * (row[i + 1] - row[i]);
    }
  }
  return row[row.length - 1];
}


function calcPrice() {
  const f   = state.format     ? findById(quoteData.formats,    state.format)     : null;
  const pap = state.paper      ? findById(quoteData.papers,     state.paper)      : null;
  const col = state.color      ? findById(quoteData.colors,     state.color)      : null;
  const cov = state.coverage   ? findById(quoteData.coverage,   state.coverage)   : null;
  const lam = state.lamination ? findById(quoteData.lamination, state.lamination) : null;
  const crd = state.cord       ? findById(quoteData.cords,      state.cord)       : null;
  const qd  = state.qty        ? findById(quoteData.quantities, state.qty)        : null;

  if (!f || !pap || !col || !cov || !lam || !crd || !qd) return null;

  const C   = quoteData.constants;
  const qty = qd.qty;

  
  const fogli = (qty / f.resa) * C.waste;

  
  const supFoglio      = (f.sheetW / 100) * (f.sheetH / 100);
  const pesoFoglio     = supFoglio * pap.gram / 1000;          
  const costoCartaBusta = (pesoFoglio * pap.pricePerKg) / f.resa;

  
  const setup = printSetupCost(col.baseId || col.id, fogli);
  if (setup === 'custom') return { custom: true, qty };
  const costoImpiantoBusta = (setup / f.resa) / qty;

  
  let inkBusta = 0;
  if ((col.baseId || col.id) !== 'cmyk' && col.n > 0) {
    const kgTeorici  = fogli * supFoglio * col.n * pap.inkFactor * cov.factor;
    const kgPerCol   = Math.ceil(kgTeorici / col.n);
    const costoInk   = kgPerCol * C.inkPerKg * col.n;
    inkBusta = costoInk / qty;
  }

  
  let lamBusta = 0;
  if (lam.rate > 0) {
    const supTot = fogli * supFoglio;
    const lamTot = Math.max(C.laminationMin, supTot * lam.rate);
    lamBusta = (lamTot / fogli) / f.resa;
  }

  
  const fust = quoteData.fustellatura[qty] !== undefined
    ? quoteData.fustellatura[qty]
    : quoteData.fustellaturaDefault;

  
  const box     = quoteData.boxes[f.box];
  const nScat   = qty / f.pzImballo;
  const pallets = Math.floor((nScat - 1) / box.perPallet) + 1;
  const logTot  = (pallets * C.palletCost) + (pallets * C.transportPerPallet) + (box.price * nScat);
  const logBusta = logTot / qty;

  
  const breakdown = [
    { label: 'Carta',                 unit: costoCartaBusta },
    { label: 'Impianto stampa',       unit: costoImpiantoBusta },
    { label: 'Inchiostro',            unit: inkBusta },
    { label: 'Plastificazione',       unit: lamBusta },
    { label: 'Corde',                 unit: crd.unitCost },
    { label: 'Allestimento',          unit: f.allestimento },
    { label: 'Listelli manici/fondi', unit: f.listelli },
    { label: 'Fustellatura',          unit: fust },
    { label: 'Scatoloni e trasporto', unit: logBusta }
  ];

  const costUnit = breakdown.reduce((sum, v) => sum + v.unit, 0);

  const ricarico  = qd.ricarico + CFG.agentPct;
  const priceUnit = costUnit * (1 + ricarico / 100);

  return {
    custom:     false,
    qty:        qty,
    breakdown:  breakdown,
    costUnit:   costUnit,
    costTotal:  costUnit * qty,
    priceUnit:  priceUnit,
    priceTotal: priceUnit * qty,
    ricarico:   ricarico
  };
}



      const catalogGroups={format:'formats',paper:'papers',color:'colors',coverage:'coverage',lamination:'lamination',cord:'cords',qty:'quantities'};
      quoteData.colors.push({id:'none',n:0,name:T.no_print});
      quoteData.printSetup.rows.none=quoteData.printSetup.breaks.map(()=>0);
      const optionSources=new Map();
      let catalogIncomplete=false;
      for(const [key,group] of Object.entries(catalogGroups)){
        const original=quoteData[group];
        const previous=state[key];
        const enabled=$$(`[data-option-source][data-group="${key}"]`).filter(el=>el.dataset.enabled==='true' && !(key==='format' && ['f4','f7'].includes(el.dataset.base) && !(el.dataset.dieImage && el.dataset.dieline)));
        const items=enabled.map(el=>{
          const base=original.find(item=>item.id===el.dataset.base);
          const custom=!base;
          const item={...(base || original[0]),id:el.dataset.optionSource,baseId:base?.id || 'custom',needsQuote:custom,quoteRequired:key==='qty' && el.dataset.quoteRequired==='true',hidden:false,title:el.dataset.title || (base ? T[base.id] || base.label || base.name : T.new_option),subtitle:el.dataset.subtitle || '',description:el.dataset.description || '',badge:el.dataset.badge || '',dieline:el.dataset.dieline || '',dieKey:el.dataset.dieKey && el.dataset.dieKey!=='auto' ? el.dataset.dieKey : (base?.id || ''),dieImage:el.dataset.dieImage || ''};
          if(custom && key==='format')item.dims={w:Math.max(1,Number(el.dataset.w)||22),s:Math.max(1,Number(el.dataset.s)||10),h:Math.max(1,Number(el.dataset.h)||29),r:Math.max(1,Number(el.dataset.r)||5)};
          if(custom && key==='qty')item.qty=Math.max(1,Math.floor(Number(el.dataset.quantity)||500));
          optionSources.set(item.id,el);
          return item;
        });
        if(!items.length){catalogIncomplete=true;items.push({...original[0],id:'unavailable-'+key,baseId:original[0].id,hidden:true,needsQuote:true,title:T.unavailable});}
        quoteData[group]=items;
        state[key]=(items.find(item=>item.baseId===previous)||items[0]).id;
      }
      const getOption=(key,id=state[key])=>findById(quoteData[catalogGroups[key]],id);
      const visibleOptions=key=>quoteData[catalogGroups[key]].filter(item=>!item.hidden);
      const originalCalcPrice=calcPrice;
      const groupTitles={format:T.format,paper:T.paper,color:T.color,coverage:T.coverage,lamination:T.lamination,cord:T.cord,qty:T.qty};
      function quantityRequiresQuote(option){
        const source=optionSources.get(option.id);
        return source ? source.dataset.quoteRequired === 'true' : false;
      }
      calcPrice=function(){
        const option=getOption('qty');
        const qty=option.qty;
        if(quantityRequiresQuote(option))return {custom:true,qty,quoteCause:'quantity',reason:T.qty_quote_reason};
        const unavailable=Object.keys(catalogGroups).filter(key=>getOption(key).hidden);
        if(unavailable.length)return {custom:true,qty,quoteCause:'unavailable',reason:T.missing_group+unavailable.map(key=>groupTitles[key]).join(', ')};
        const missing=Object.keys(catalogGroups).filter(key=>getOption(key).needsQuote);
        if(missing.length)return {custom:true,qty,quoteCause:'missing_rate',reason:T.missing_rate+missing.map(key=>groupTitles[key]+' — '+getOption(key).title).join('; ')};
        const result=originalCalcPrice();
        if(!result || result.custom || !Number.isFinite(result.priceTotal) || !Number.isFinite(result.priceUnit))return {custom:true,qty,quoteCause:'rate_limit',reason:T.rate_limit};
        return result;
      };
      function optionBadge(item){
        const badge=document.createElement('span');badge.className='m3c-badge';badge.textContent=item.badge;return badge;
      }
      function bindBlock(element,item){
        const source=optionSources.get(item.id);
        if(source)for(const attr of source.attributes)if(attr.name.startsWith('data-shopify-'))element.setAttribute(attr.name,attr.value);
        element.dataset.blockId=item.id;
      }

      const leadDays=Math.max(30,Math.floor(Number(CFG.leadDays)||30));
      const businessDays=CFG.dayMode!=='calendar';
      const closures=new Set(String(CFG.closedDates||'').split(/[\s,;]+/).filter(Boolean));
      let productionMode='standard',requestedDate='';
      const isoDay=date=>date.toISOString().slice(0,10);
      function todayISO(){
        let parts;
        try{parts=new Intl.DateTimeFormat('en-CA',{timeZone:CFG.timezone||'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());}
        catch{parts=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Rome',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());}
        const val=type=>parts.find(p=>p.type===type).value;
        return `${val('year')}-${val('month')}-${val('day')}`;
      }
      function validDay(value){
        if(!/^\d{4}-\d{2}-\d{2}$/.test(value))return false;
        const d=new Date(value+'T12:00:00Z');return Number.isFinite(d.getTime()) && isoDay(d)===value;
      }
      function workDay(date){return date.getUTCDay()!==0 && date.getUTCDay()!==6 && !closures.has(isoDay(date));}
      function earliestDate(from=todayISO()){
        const date=new Date(from+'T12:00:00Z');let remaining=leadDays;
        while(remaining>0){date.setUTCDate(date.getUTCDate()+1);if(!businessDays || workDay(date))remaining--;}
        return isoDay(date);
      }
      function scheduleValid(){
        if(productionMode==='standard')return true;
        return validDay(requestedDate) && requestedDate>=earliestDate() && (!businessDays || workDay(new Date(requestedDate+'T12:00:00Z')));
      }
      function dateLabel(value){return new Intl.DateTimeFormat('it-IT',{day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(value+'T12:00:00Z'));}
      function scheduleData(){return {mode:productionMode,requestedShipDate:productionMode==='standard'?earliestDate():requestedDate,minimumDays:leadDays,dayMode:businessDays?'business':'calendar',calculatedFrom:todayISO(),confirmed:false};}
      function updateSchedule(){
        const first=earliestDate();
        $('[data-standard-date]').textContent=dateLabel(first);
        $('[data-programmed-min]').textContent=`${leadDays}+ ${businessDays?T.business_days:T.calendar_days}`;
        $('[data-schedule-input]').min=first;
        $('[data-schedule-field]').hidden=productionMode!=='scheduled';
        $$('[data-production-mode]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.productionMode===productionMode)));
        $('[data-production-rule]').textContent=`${T.production_min} ${leadDays} ${businessDays?T.business_days:T.calendar_days}. ${T.production_start}`;
        $('[data-schedule-error]').textContent=scheduleValid()?'':`${T.schedule_invalid} ${dateLabel(first)}. ${businessDays?T.schedule_workdays:''}`;
      }
      $$('[data-production-mode]').forEach(button=>button.addEventListener('click',()=>{
        productionMode=button.dataset.productionMode;
        if(productionMode==='scheduled' && !requestedDate){requestedDate=earliestDate();$('[data-schedule-input]').value=requestedDate;}
        update();
      }));
      $('[data-schedule-input]').addEventListener('input',event=>{requestedDate=event.target.value;update();});

      function label(key) { return getOption(key)?.title || T.unavailable; }
      function status(message) { $('[data-status]').textContent = message; }
      function svgFor(format, compact = false, flat = true) {
        const {w,h} = format.dims;
        const W = w * 10, H = h * 10;
        const handleH = Math.min(85, W * .3), stroke = Math.max(3,W*.012);
        const maxLogoH = H * .27;
        const logoW = W * Number(design.logo_size)/100;
        const logoY = H * Number(design.logo_y)/100;
        const fill = compact ? '#e7dece' : design.bag_color;
        const content = compact ? '' : `${logo ? `<image href="${esc(logo)}" x="${(W-logoW)/2}" y="${logoY-maxLogoH/2}" width="${logoW}" height="${maxLogoH}" preserveAspectRatio="xMidYMid meet"/>` : ''}<text x="${W/2}" y="${H*.81}" text-anchor="middle" font-family="Arial,sans-serif" font-size="${Math.min(W*.085,W*1.4/Math.max(1,design.text.length))}" font-weight="700" fill="${esc(design.ink_color)}">${esc(design.text)}</text>`;
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${flat ? `-12 ${-handleH-14} ${W+24} ${H+handleH+30}` : `0 0 ${W} ${H}`}" role="img" aria-label="${esc(T.preview)}"><rect width="${W}" height="${H}" fill="${esc(fill)}" stroke="#000000" stroke-opacity=".16"/><path d="M ${W*.3} 18 V ${-handleH*.52} Q ${W*.5} ${-handleH*1.18} ${W*.7} ${-handleH*.52} V 18" fill="none" stroke="${esc(compact ? '#48453e' : design.cord_color)}" stroke-width="${stroke}" stroke-linecap="round"/><path d="M 0 12 H ${W}" stroke="#000000" stroke-opacity=".1"/>${content}</svg>`;
      }
      const groups = {paper:'papers',color:'colors',coverage:'coverage',lamination:'lamination',cord:'cords',qty:'quantities'};
      const instanceId = crypto.randomUUID();
      const dialog = $('.m3c-dialog');
      let detailChoice = null;
      function sampleImage(id) {
        const entry=Object.values(catalogGroups).flatMap(group=>quoteData[group]).find(item=>item.id===id);
        const originalId=entry?.baseId || id;
        const provided = optionSources.get(id)?.querySelector('img') || $(`[data-sample-source="${originalId}"] img`);
        const title=entry?.title || T[id] || T.new_option;
        if (provided) {
          const clone = provided.cloneNode(true); clone.alt = title; clone.loading = 'eager'; return clone;
        }
        const category=optionSources.get(id)?.dataset.group;
        if(category==='color' || category==='lamination'){
          const noPrint=originalId==='none';
          const gloss=originalId==='lucida' || title.toLowerCase().includes('lucid');
          const graphic=category==='color' ? `<circle cx="30" cy="30" r="18" fill="${noPrint?'#edf1f6':'#00c6ef'}" stroke="#91a7bb"/><circle cx="59" cy="30" r="18" fill="${noPrint?'#edf1f6':'#ef1688'}" stroke="#91a7bb"/><circle cx="30" cy="59" r="18" fill="${noPrint?'#edf1f6':'#26333d'}" stroke="#91a7bb"/><circle cx="59" cy="59" r="18" fill="${noPrint?'#edf1f6':'#ffe037'}" stroke="#91a7bb"/>${noPrint?'<path d="M12 77L78 12" stroke="#ed2642" stroke-width="5"/>':''}` : `<circle cx="45" cy="45" r="32" fill="#c5d2df" stroke="#8da5bc" stroke-width="3"/>${gloss?'<circle cx="58" cy="29" r="12" fill="white"/><path d="M21 55A27 27 0 0 1 46 18" fill="none" stroke="white" stroke-width="3"/>':''}${originalId==='senza'?'<path d="M20 72L73 19" stroke="#8798ac" stroke-width="3"/>':''}`;
          const image=document.createElement('img');image.src='data:image/svg+xml;charset=utf-8,'+encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90"><rect width="90" height="90" rx="12" fill="#fff"/>${graphic}</svg>`);image.alt=title;image.width=90;image.height=90;return image;
        }
        id=originalId;
        const grain = id === 'usomano' || id === 'senza';
        const cord = id === 'cotone';
        const gloss = id === 'lucida' || id === 'monopatinata';
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 720 440"><defs><filter id="noise"><feTurbulence type="fractalNoise" baseFrequency="${grain ? '.55' : '.85'}" numOctaves="3" stitchTiles="stitch"/><feColorMatrix type="saturate" values="0"/></filter><linearGradient id="light" x2="1" y2=".4"><stop stop-color="#fff" stop-opacity="0"/><stop offset=".45" stop-color="#fff" stop-opacity=".08"/><stop offset=".53" stop-color="#fff" stop-opacity=".9"/><stop offset=".65" stop-color="#fff" stop-opacity=".1"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></linearGradient></defs><rect width="720" height="440" fill="${grain ? '#eee9dc' : '#f5f4f0'}"/><rect width="720" height="440" filter="url(#noise)" opacity="${grain ? '.20' : '.07'}"/>${cord ? '<path d="M160 380 V150 C160 -5 555 -5 555 150 V380" fill="none" stroke="#d0c3a9" stroke-width="36"/><path d="M160 380 V150 C160 -5 555 -5 555 150 V380" fill="none" stroke="#eee3cc" stroke-width="30" stroke-dasharray="5 4"/>' : '<rect x="85" y="70" width="550" height="300" rx="4" fill="#51765f"/><circle cx="470" cy="220" r="100" fill="#dcbd87"/><path d="M85 330L290 130 450 370H85" fill="#24453b"/><text x="120" y="160" font-family="Arial" font-size="28" fill="white">EMMETRE</text>'}${gloss ? '<rect width="720" height="440" fill="url(#light)"/>' : ''}${id === 'opaca' ? '<rect width="720" height="440" fill="#fff" opacity=".13"/>' : ''}</svg>`;
        const image = document.createElement('img'); image.src = 'data:image/svg+xml;charset=utf-8,'+encodeURIComponent(svg); image.alt = `${title} — ${T.sample}`; image.width = 720; image.height = 440; return image;
      }
      function selectChoice(key,id) {if(key==='format' && state[key]!==id)clearArtwork(true);state[key] = id; update();}
      function openDetails(key,id) {
        detailChoice = {key,id};
        const item=getOption(key,id);
        $('[data-detail-title]').textContent = item.title;
        $('[data-detail-image]').replaceChildren(sampleImage(id));
        $('[data-detail-desc]').textContent = item.description || $(`[data-sample-source="${item.baseId}"]`)?.dataset.description || T[item.baseId+'_desc'] || (key==='format' ? T.format_info : key==='qty' ? T.qty_info : T.option_info);
        $('[data-detail-note]').textContent = (optionSources.get(id)?.querySelector('img') || $(`[data-sample-source="${item.baseId}"] img`)) ? T.real_sample : T.sample_note;
        $('[data-detail-choose]').textContent = state[key] === id ? T.selected : T.choose;
        dialog.showModal();
      }
      $('[data-detail-close]').addEventListener('click',() => dialog.close());
      dialog.addEventListener('click',event => {if (event.target === dialog) {const r=dialog.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom)dialog.close();}});
      $('[data-detail-choose]').addEventListener('click',() => {if(detailChoice)selectChoice(detailChoice.key,detailChoice.id);dialog.close();});
      for (const [key,group] of Object.entries(groups)) {
        if (key === 'qty') continue;
        const list = $(`[data-options="${key}"]`);
        const visual = true;
        visibleOptions(key).forEach(item => {
          const row=document.createElement('div');row.className='m3c-choice-row';row.dataset.choiceKey=key;row.dataset.choiceId=item.id;bindBlock(row,item);if(item.badge)row.append(optionBadge(item));
          const label=document.createElement('label');label.className='m3c-choice-label';
          const radio=document.createElement('input');radio.type='radio';radio.name=instanceId+'-'+key;radio.value=item.id;radio.dataset.choice=key;radio.checked=state[key]===item.id;
          radio.addEventListener('change',()=>selectChoice(key,item.id));label.append(radio);
          if(visual){const swatch=document.createElement('span');swatch.className='m3c-swatch';swatch.append(sampleImage(item.id));label.append(swatch);}
          const body=document.createElement('span');body.className='m3c-choice-copy';const name=document.createElement('strong');name.textContent=item.title;body.append(name);
          if(item.subtitle){const desc=document.createElement('small');desc.textContent=item.subtitle;body.append(desc);}
          label.append(body);row.append(label);
          if(visual){const detail=document.createElement('button');detail.type='button';detail.className='m3c-choice-detail';detail.textContent=T.details;detail.setAttribute('aria-label',T.details+' '+item.title);detail.addEventListener('click',()=>openDetails(key,item.id));row.append(detail);}
          list.append(row);
        });
      }
      visibleOptions('format').forEach(format => {
        const wrapper=document.createElement('div');wrapper.className='m3c-model-option';bindBlock(wrapper,format);
        const button=document.createElement('button');button.type='button';button.dataset.format=format.id;
        button.innerHTML=svgFor(format,true);const title=document.createElement('span');title.textContent=format.title;button.append(title);
        if(format.badge)wrapper.append(optionBadge(format));
        button.addEventListener('click',()=>selectChoice('format',format.id));
        const detail=document.createElement('button');detail.type='button';detail.className='m3c-choice-detail';detail.textContent=T.details;
        detail.setAttribute('aria-label',T.details+' '+format.title);detail.addEventListener('click',()=>openDetails('format',format.id));
        wrapper.append(button,detail);$('[data-models]').append(wrapper);
      });
      function dieFiles(){
        const format=getOption('format');
        const ref=$$('[data-built-die]').find(el=>el.dataset.builtDie===format.dieKey);
        return {image:format.dieImage || ref?.dataset.preview || '',pdf:format.dieline || $(`[data-dieline-format="${format.baseId}"]`)?.dataset.url || ref?.dataset.pdf || ''};
      }
      let displayedDie='';
      function drawDieline(){
        const files=dieFiles();
        const key=getOption('format').id+'|'+files.image;
        if(displayedDie===key)return;displayedDie=key;
        const flat=$('[data-flat]');flat.replaceChildren();flat.scrollTop=0;flat.scrollLeft=0;
        if(!files.image){flat.textContent=T.die_unavailable;return;}
        const sheet=document.createElement('div');sheet.className='m3c-dieline-sheet';
        const img=document.createElement('img');img.src=files.image;img.alt=T.view2d+' — '+label('format');img.draggable=false;
        img.addEventListener('error',()=>{const fallback=$$('[data-built-die]').find(el=>el.dataset.builtDie===getOption('format').dieKey)?.dataset.preview;if(fallback && img.getAttribute('src')!==fallback){img.src=fallback;}else{sheet.textContent=T.die_error;}});sheet.append(img);flat.append(sheet);
      }
      const jobInput=$('[data-job-name]');
      const jobName=()=>jobInput.value.trim();
      const jobValid=()=>jobName().length>0 && jobName().length<=100;
      function requireJobName(){
        jobInput.setCustomValidity(jobValid() ? '' : T.job_required);
        if(jobValid()){jobInput.removeAttribute('aria-invalid');return true;}
        jobInput.setAttribute('aria-invalid','true');jobInput.focus();jobInput.reportValidity();return false;
      }
      jobInput.addEventListener('input',()=>{jobInput.setCustomValidity('');jobInput.removeAttribute('aria-invalid');update();});
      $('[data-whatsapp]').addEventListener('click',event=>{if(calcPrice().custom && !requireJobName())event.preventDefault();});
      function allowed(p) {
        if (!jobValid() || !scheduleValid() || !p || p.custom || !CFG.cartEnabled || cartBusy || logoBusy) return false;
        const units = Math.round(p.priceTotal*100);
        return CFG.currency === 'EUR' && CFG.price === 1 && CFG.variantId > 0 && CFG.available && !CFG.sellingPlan && !CFG.priceBreaks && Number.isSafeInteger(units) && units >= CFG.minimum && (units-CFG.minimum)%CFG.increment === 0 && (!CFG.maximum || units <= CFG.maximum);
      }
      function update() {
        updateSchedule();
        $('[data-upload-summary]').textContent=artworkFile?.name || T.upload_empty;
        $('[data-print-summary]').textContent=label('color')+' · '+label('lamination');
        const currentQty = state.qty;
        const tierContainer = $('[data-tiers]'); tierContainer.replaceChildren();
        visibleOptions('qty').forEach(tier => {
          state.qty = tier.id; const price = calcPrice(); state.qty = currentQty;
          const button = document.createElement('button'); button.type='button'; button.dataset.tier=tier.id;
          button.setAttribute('aria-pressed',String(tier.id === currentQty));
          const amount=document.createElement('strong');amount.textContent=tier.title || tier.qty.toLocaleString('it-IT');
          const unit=document.createElement('span');unit.textContent=price.custom ? (price.quoteCause==='quantity' ? T.quote_only : T.price_check) : money(price.priceUnit);
          if([3000,4000,5000].includes(Number(tier.qty)) && !price.custom){unit.classList.add('m3c-obscured-price');unit.setAttribute('aria-hidden','true');button.setAttribute('aria-label',amount.textContent+' pezzi. Seleziona per vedere il totale.');}
          if(price.custom){button.title=price.reason || T.price_check;button.setAttribute('aria-label',amount.textContent+' · '+unit.textContent+' · '+button.title);}
          const wrapper=document.createElement('div');wrapper.className='m3c-tier-option';bindBlock(wrapper,tier);if(tier.badge)wrapper.append(optionBadge(tier));
          button.append(amount,unit);button.addEventListener('click',()=>{state.qty=tier.id;update();$(`[data-tier="${tier.id}"]`).focus();});wrapper.append(button);tierContainer.append(wrapper);
        });
        $('[data-qty-summary]').textContent=findById(quoteData.quantities,currentQty).qty.toLocaleString('it-IT')+' pz';
        const dielineURL=dieFiles().pdf;
        const dielineLink=$('[data-dieline-link]');
        if(dielineURL){dielineLink.href=dielineURL;dielineLink.removeAttribute('aria-disabled');dielineLink.removeAttribute('tabindex');}
        else{dielineLink.removeAttribute('href');dielineLink.setAttribute('aria-disabled','true');dielineLink.setAttribute('tabindex','-1');}
        $('[data-dieline-unavailable]').hidden=!!dielineURL;
        const dimensions=findById(quoteData.formats,state.format).dims;
        $('[data-dieline-size]').textContent=`${dimensions.w} × ${dimensions.s} × ${dimensions.h} + ${dimensions.r} cm`;

        $$('[data-choice]').forEach(input => {input.checked = state[input.dataset.choice] === input.value;});
        $$('[data-choice-key]').forEach(row => row.classList.toggle('is-selected',state[row.dataset.choiceKey] === row.dataset.choiceId));
        $$('[data-choice-summary]').forEach(el => {el.textContent = label(el.dataset.choiceSummary);});
        const format = findById(quoteData.formats,state.format);
        const p = calcPrice();
        const {w,s,h,r} = format.dims;
        $$('[data-format]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.format === state.format)));
        drawDieline();
        $$('[data-dimension]').forEach(el=>{el.value=String(format.dims[el.dataset.dimension]);});
        $('[data-rim]').textContent=String(r);
        $('[data-view-format]').textContent=`${w} × ${s} × ${h} cm`;
        const nextVisual=JSON.stringify([format.dims,getOption('paper').baseId,getOption('lamination').baseId]);
        if(viewer && visualSignature!==nextVisual){visualSignature=nextVisual;viewer.set({dims:format.dims,paper:getOption('paper').baseId,finish:getOption('lamination').baseId});}
        $('[data-dims]').textContent = `${w} × ${s} × ${h} cm · ${T.dimensions} · R ${r} cm`;
        $('[data-total]').textContent = p.custom ? (p.quoteCause==='quantity' ? T.quote_only : T.price_check) : money(Math.round(p.priceTotal*100)/100);
        $('[data-unit]').textContent = p.custom ? (p.reason || T.custom) : `${money(p.priceUnit)} / ${T.unit}`;
        $('[data-summary]').textContent = `${p.qty.toLocaleString('it-IT')} · ${label('paper')} · ${label('color')} · ${label('lamination')}`;
        const contact=$('[data-whatsapp]');
        const phone=String(CFG.whatsapp || '').replace(/[^0-9]/g,'');
        const quoteMessage=[T.quote_message,T.job_name+': '+jobName(),label('format'),label('paper'),label('color'),label('coverage'),label('lamination'),label('cord'),p.qty.toLocaleString('it-IT')+' pezzi',location.origin+location.pathname].join('\n');
        contact.textContent=p.custom ? T.request_quote : T.whatsapp;
        if(phone.length>=8 && phone.length<=15){
          const message=['Buongiorno, vorrei informazioni su questa shopper:',jobName()?T.job_name+': '+jobName():'',label('format'),label('paper'),label('color'),label('lamination'),label('cord'),p.qty.toLocaleString('it-IT')+' pezzi',p.custom?'Preventivo su richiesta':money(Math.round(p.priceTotal*100)/100),location.origin+location.pathname].join('\n');
          contact.href='https://wa.me/'+phone+'?text='+encodeURIComponent(p.custom ? quoteMessage : message);contact.removeAttribute('aria-disabled');contact.removeAttribute('tabindex');
        }else if(p.custom && CFG.quoteEmail){
          contact.href='mailto:'+encodeURIComponent(CFG.quoteEmail)+'?subject='+encodeURIComponent(T.quote_subject)+'&body='+encodeURIComponent(quoteMessage);contact.removeAttribute('aria-disabled');contact.removeAttribute('tabindex');
        }else{contact.removeAttribute('href');contact.setAttribute('aria-disabled','true');contact.setAttribute('tabindex','-1');}
        const add = $('[data-add]');
        add.hidden = !CFG.cartEnabled || p.custom;
        add.disabled = !allowed(p);
        add.textContent = cartBusy ? T.adding : T.add;
        jobInput.disabled=cartBusy;
        $('[data-mode]').textContent = !jobValid() ? T.job_required : !scheduleValid() ? T.schedule_block : !CFG.cartEnabled ? T.demo : (p.custom ? (p.reason || T.custom) : allowed(p) || cartBusy || logoBusy ? T.cart_note : T.bad_product);
      }
      $$('[data-key]').forEach(input => input.addEventListener('input', () => {
        const key = input.dataset.key;
        if (Object.hasOwn(state,key)) state[key] = input.value;
        else design[key] = input.type === 'range' ? Number(input.value) : input.value;
        update();
      }));
      const viewerHost=$('[data-preview]');
      let viewer=null,visualSignature='',activeView='3d',netZoom=1;
      let lifetime=new AbortController();
      const setView=view=>{
        activeView=view==='3d'&&viewer?'3d':'2d';
        $('[data-flat]').hidden=activeView==='3d';$('[data-scene]').hidden=activeView!=='3d';$('[data-turn]').hidden=activeView!=='3d';
        $$('[data-view]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.view===activeView)));
        if(viewer)viewer.draw();
      };
      const failed3D=()=>{$('[data-view-error]').textContent=T.webgl_error;$('[data-view-error]').hidden=false;$('[data-view="3d"]').disabled=true;setView('2d');};
      try{viewer=new M3ShopperViewer($('[data-canvas]'),$('[data-axis-overlay]'),failed3D);}catch{failed3D();}
      $$('[data-view]').forEach(button=>button.addEventListener('click',()=>setView(button.dataset.view)));
      $('[data-axes]').addEventListener('change',e=>{if(viewer){viewer.axes=e.target.checked;viewer.draw();}});
      const changeZoom=factor=>{if(activeView==='3d'){viewer.zoomBy(factor);return;}netZoom=Math.max(1,Math.min(4,netZoom*factor));$('[data-stage]').style.setProperty('--zoom',String(netZoom));};
      $('[data-zoom-in]').addEventListener('click',()=>changeZoom(1.2));
      $('[data-zoom-out]').addEventListener('click',()=>changeZoom(1/1.2));
      $('[data-reset-view]').addEventListener('click',()=>{netZoom=1;$('[data-stage]').style.setProperty('--zoom','1');$('[data-flat]').scrollTo(0,0);viewer?.reset();});
      const syncFullscreen=()=>{const full=document.fullscreenElement===viewerHost||viewerHost.classList.contains('is-full'),button=$('[data-fullscreen]');button.setAttribute('aria-pressed',String(full));button.setAttribute('aria-label',full?T.exit_fullscreen:T.fullscreen);button.title=full?T.exit_fullscreen:T.fullscreen;viewer?.draw();};
      $('[data-fullscreen]').addEventListener('click',async()=>{
        if(document.fullscreenElement===viewerHost){await document.exitFullscreen();}
        else if(viewerHost.classList.contains('is-full')){viewerHost.classList.remove('is-full');}
        else{try{if(viewerHost.requestFullscreen)await viewerHost.requestFullscreen();else viewerHost.classList.add('is-full');}catch{viewerHost.classList.add('is-full');}}
        syncFullscreen();
      });
      const layoutSize=()=>{root.style.setProperty('--m3-page-width',document.documentElement.clientWidth+'px');root.style.setProperty('--m3-view-height',Math.max(640,Math.min(1000,window.innerHeight-72))+'px');};
      const observer=new ResizeObserver(layoutSize);
      const connectGlobals=()=>{
        document.addEventListener('fullscreenchange',syncFullscreen,{signal:lifetime.signal});
        document.addEventListener('keydown',e=>{if(e.key==='Escape'){viewerHost.classList.remove('is-full');syncFullscreen();}},{signal:lifetime.signal});
        window.addEventListener('resize',layoutSize,{signal:lifetime.signal});observer.observe(document.documentElement);layoutSize();
      };
      connectGlobals();
      this.disposeViewer=()=>{lifetime.abort();observer.disconnect();viewer?.destroy();};
      this.resumeViewer=()=>{lifetime=new AbortController();try{viewer=new M3ShopperViewer($('[data-canvas]'),$('[data-axis-overlay]'),failed3D);viewer.axes=$('[data-axes]').checked;visualSignature='';}catch{failed3D();}connectGlobals();update();};
      setView(root.dataset.defaultView);
      function clearArtwork(changed = false) {
        const hadFile = artworkFile || logoBusy; fileVersion++; logoBusy=false;artworkFile=null;artworkFormat=null;
        $('[data-pdf-input]').value='';$('[data-pdf-row]').hidden=true;
        $('[data-pdf-status]').textContent=changed && hadFile ? T.pdf_changed : '';
      }
      async function acceptPDF(files) {
        if(!files.length)return;
        clearArtwork(); const version=fileVersion; const file=files[0];
        if(files.length !== 1 || !/\.pdf$/i.test(file.name) || file.size===0 || file.size>20*1024*1024){$('[data-pdf-status]').textContent=T.pdf_invalid;update();return;}
        logoBusy=true;$('[data-pdf-status]').textContent=T.pdf_loading;update();
        try {
          const header=await file.slice(0,5).text();
          if(version!==fileVersion)return;
          if(header!=='%PDF-')throw new Error('pdf');
          artworkFile=file;artworkFormat=state.format;
          $('[data-pdf-name]').textContent=`${file.name} · ${(file.size/1024/1024).toFixed(2)} MB`;
          $('[data-pdf-row]').hidden=false;$('[data-pdf-status]').textContent=T.pdf_local;
        }catch {if(version===fileVersion)$('[data-pdf-status]').textContent=T.pdf_invalid;}
        finally{if(version===fileVersion){logoBusy=false;update();}}
      }
      $('[data-pdf-input]').addEventListener('change',event=>acceptPDF([...event.target.files]));
      $('[data-pdf-remove]').addEventListener('click',()=>{clearArtwork();update();});
      const dropzone=$('[data-dropzone]');
      ['dragenter','dragover'].forEach(name=>dropzone.addEventListener(name,event=>{event.preventDefault();dropzone.classList.add('is-drag');}));
      ['dragleave','drop'].forEach(name=>dropzone.addEventListener(name,event=>{event.preventDefault();dropzone.classList.remove('is-drag');}));
      dropzone.addEventListener('drop',event=>acceptPDF([...event.dataTransfer.files]));
      $('[data-ppwr]').addEventListener('click',()=>{
        if(!CFG.ppwrEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(CFG.ppwrEmail))return status(T.ppwr_missing);
        const f=findById(quoteData.formats,state.format);
        const body=[T.ppwr_body,`${f.dims.w} × ${f.dims.s} × ${f.dims.h} + ${f.dims.r} cm`,label('paper'),label('color'),label('coverage'),label('lamination'),label('cord'),findById(quoteData.quantities,state.qty).qty+' pz'].join('\n');
        const a=document.createElement('a');a.href=`mailto:${encodeURIComponent(CFG.ppwrEmail)}?subject=${encodeURIComponent(T.ppwr_subject)}&body=${encodeURIComponent(body)}`;a.click();status(T.ppwr_draft);
      });
      function project() {
        const p = calcPrice();
        return {version:2,production:scheduleData(),createdAt:new Date().toISOString(),selection:{...state},selectedOptions:Object.fromEntries(Object.keys(catalogGroups).map(key=>[key,{title:getOption(key).title,base:getOption(key).baseId}])),dimensions:findById(quoteData.formats,state.format).dims,artwork:{name:artworkFile?.name || '',size:artworkFile?.size || 0,format:artworkFormat,productionFileUploaded:false},quote:{currency:'EUR',quantity:p.qty,requiresCustomQuote:p.custom,totalCents:p.custom ? null : Math.round(p.priceTotal*100)}};
      }
      function download(contents,type,name) {
        const url = URL.createObjectURL(new Blob([contents],{type}));
        const link = document.createElement('a'); link.href = url; link.download = name;
        document.body.append(link); link.click(); link.remove();
        setTimeout(() => URL.revokeObjectURL(url),1000);
      }
      $('[data-add]').addEventListener('click',async () => {
        if(!requireJobName())return;
        const p = calcPrice();
        if (!allowed(p)) return;
        const quantity = Math.round(p.priceTotal*100);
        const submittedFile = artworkFile;
        const model = findById(quoteData.formats,state.format);
        const configurationId = crypto.randomUUID();
        const properties = {
          'Nome lavorazione':jobName(),
          [T.mode_property]:productionMode==='standard'?T.production_standard:T.production_scheduled,
          [T.shipping_property]:scheduleData().requestedShipDate,
          [T.lead_property]:`${leadDays} ${businessDays?T.business_days:T.calendar_days}`,
          '_m3_production':JSON.stringify(scheduleData()),
          [T.format]:`${model.dims.w} × ${model.dims.s} × ${model.dims.h} + ${model.dims.r} cm`,
          [T.qty]:String(p.qty),[T.paper]:label('paper'),[T.color]:label('color'),[T.coverage]:label('coverage'),[T.lamination]:label('lamination'),[T.cord]:label('cord'),
          '_File grafica':artworkFile?.name || '—',
          'Quantità':`${p.qty.toLocaleString('it-IT')} pz`, 'Prezzo':money(quantity/100), '_scatole':String(p.qty), '_Modello':'Shopper Sprint', '_Prezzo unitario':String(p.priceUnit.toFixed(4)), '_Unità di prezzo':`${quantity} × 0,01 EUR = ${money(quantity/100)} per ${p.qty} shopper`, _m3_configuration_id:configurationId,_m3_mode:'cent_units_demo',_m3_total_cents:String(quantity),_m3_shopper_qty:String(p.qty),_m3_selection:JSON.stringify(state)
        };
        cartBusy = true; status(''); update();
        try {
          const formData=new FormData();formData.append('id',String(CFG.variantId));formData.append('quantity',String(quantity));
          for(const [key,value] of Object.entries(properties))formData.append(`properties[${key}]`,value);
          if(submittedFile)formData.append('properties[File grafica PDF]',submittedFile,submittedFile.name);
          const response = await fetch(CFG.addUrl.replace(/\.js$/,''),{method:'POST',body:formData});
          if (!response.ok) throw new Error(T.cart_error);
          const check = await fetch(`${CFG.cartUrl}.js`,{headers:{'Accept':'application/json'},cache:'no-store'});
          if (!check.ok) throw new Error(T.cart_error);
          const cart = await check.json();
          const confirmed = cart.items?.find(line => line.properties?._m3_configuration_id === configurationId);
          if (submittedFile && !confirmed?.properties?.['File grafica PDF']) throw new Error(T.cart_error);
          if (cart.currency !== 'EUR' || !confirmed || confirmed.quantity !== quantity || confirmed.final_line_price !== quantity) throw new Error(T.cart_error);
          window.location.assign(CFG.cartUrl);
        } catch { status(T.cart_error); }
        finally {cartBusy = false; update();}
      });
      root.addEventListener('shopify:block:select',event=>{
        const id=event.detail?.blockId;
        const card=$$('[data-block-id]').find(el=>el.dataset.blockId===id);
        if(card){const panel=card.closest('details');if(panel)panel.open=true;card.scrollIntoView({block:'nearest'});}
      });
      update();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velaris"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('velaris-gradient')) return;
  const vertexSource = `
attribute vec2 position;
varying vec2 vUv;
void main() {
  vUv = position * 0.5 + 0.5;
  gl_Position = vec4(position, 0.0, 1.0);
}
`;
  const fragmentSource = `
#ifdef GL_FRAGMENT_PRECISION_HIGH
precision highp float;
#else
precision mediump float;
#endif
varying vec2 vUv;

uniform vec2  u_resolution;
uniform float u_time;
uniform float u_grain;
uniform vec3  u_colors[4];
uniform vec3  u_bg;

vec3 permute(vec3 x) { return mod(((x*34.0)+1.0)*x, 289.0); }

float snoise(vec2 v){
  const vec4 C = vec4(0.211324865405187, 0.366025403784439,
           -0.577350269189626, 0.024390243902439);
  vec2 i  = floor(v + dot(v, C.yy) );
  vec2 x0 = v -   i + dot(i, C.xx);
  vec2 i1 = (x0.x > x0.y) ? vec2(1.0, 0.0) : vec2(0.0, 1.0);
  vec4 x12 = x0.xyxy + C.xxzz;
  x12.xy -= i1;
  i = mod(i, 289.0);
  vec3 p = permute( permute( i.y + vec3(0.0, i1.y, 1.0 ))
  + i.x + vec3(0.0, i1.x, 1.0 ));
  vec3 m = max(0.5 - vec3(dot(x0,x0), dot(x12.xy,x12.xy),
    dot(x12.zw,x12.zw)), 0.0);
  m = m*m ;
  m = m*m ;
  vec3 x = 2.0 * fract(p * C.www) - 1.0;
  vec3 h = abs(x) - 0.5;
  vec3 ox = floor(x + 0.5);
  vec3 a0 = x - ox;
  m *= 1.79284291400159 - 0.85373472095314 * ( a0*a0 + h*h );
  vec3 g;
  g.x  = a0.x  * x0.x  + h.x  * x0.y;
  g.yz = a0.yz * x12.xz + h.yz * x12.yw;
  return 130.0 * dot(m, g);
}

void main() {
  vec2 uv = vUv;
  float ratio = u_resolution.x / u_resolution.y;
  vec2 p = uv - 0.5;
  p.x *= ratio;

  float t = u_time * 0.1;

  float n1 = snoise(p * 0.4 + vec2(t * 0.2, -t * 0.3));
  float n2 = snoise(p * 0.55 + vec2(-t * 0.15, t * 0.25) + n1 * 0.25);
  float n3 = snoise(p * 0.75 + vec2(t * 0.1, -t * 0.2) + n2 * 0.2);

  vec3 col = u_bg;
  
  float dist = length(p) * 1.5;
  float vignette = 1.0 - smoothstep(0.3, 1.2, dist);
  
  col = mix(col, u_colors[0], smoothstep(-0.2, 0.5, n1) * 0.85);
  col = mix(col, u_colors[1], smoothstep(-0.1, 0.6, n2) * 0.7);
  col = mix(col, u_colors[2], smoothstep(-0.3, 0.4, n3) * 0.6);
  col = mix(col, u_colors[3], smoothstep(0.0, 0.7, n1 * n2) * 0.5);

  float glow = (1.0 - smoothstep(0.0, 0.8, dist)) * 0.3;
  col += u_colors[1] * glow;

  col = mix(col * 0.2, col, vignette);

  float grain = fract(sin(dot(uv, vec2(12.9898, 78.233))) * 43758.5453 + u_time);
  col += (grain - 0.5) * u_grain * 0.1;

  gl_FragColor = vec4(col, 1.0);
}
`;
  class VelarisGradient extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => {
        if (this.isConnected) this.initialize();
      });
    }
    initialize() {
      this.dispose();
      const canvas = this.querySelector('canvas');
      if (!canvas) {
        const video = this.querySelector('video');
        if (video) this.initializeVideo(video);
        return;
      }
      const gl = canvas.getContext('webgl', { alpha: false, antialias: false });
      if (!gl) return;
      let program, buffer;
      const shaders = [];
      let frame = 0;
      let ro, io;
      let visible = true;
      let elapsed = 0;
      let previous = null;
      let lost = false;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const speed = Number(this.dataset.speed);
      const animated = this.dataset.animate === 'true' && speed > 0;
      const rgb = value => {
        let hex = value.replace('#', '');
        if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
        return [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16) / 255);
      };
      const stop = () => { cancelAnimationFrame(frame); frame = 0; previous = null; };
      const onLost = event => { event.preventDefault(); lost = true; stop(); canvas.style.opacity = '0'; };
      const onRestored = () => this.initialize();
      this.cleanup = () => {
        stop();
        ro?.disconnect();
        io?.disconnect();
        document.removeEventListener('visibilitychange', sync);
        motion.removeEventListener('change', sync);
        canvas.removeEventListener('webglcontextlost', onLost);
        canvas.removeEventListener('webglcontextrestored', onRestored);
        if (buffer) gl.deleteBuffer(buffer);
        if (program) gl.deleteProgram(program);
        shaders.forEach(shader => gl.deleteShader(shader));
      };
      let locations;
      const draw = () => {
        if (lost) return;
        gl.uniform2f(locations.resolution, canvas.width, canvas.height);
        gl.uniform1f(locations.time, elapsed * speed);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      };
      const render = timestamp => {
        frame = 0;
        if (previous !== null) elapsed += Math.min((timestamp - previous) / 1000, 0.1);
        previous = timestamp;
        draw();
        frame = requestAnimationFrame(render);
      };
      function sync() {
        stop();
        if (lost || document.hidden || !visible) return;
        draw();
        if (animated && !motion.matches) frame = requestAnimationFrame(render);
      }
      try {
        const compile = (type, source) => {
          const shader = gl.createShader(type);
          if (!shader) throw new Error('Shader unavailable');
          shaders.push(shader);
          gl.shaderSource(shader, source);
          gl.compileShader(shader);
          if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(shader));
          return shader;
        };
        program = gl.createProgram();
        if (!program) throw new Error('Program unavailable');
        gl.attachShader(program, compile(gl.VERTEX_SHADER, vertexSource));
        gl.attachShader(program, compile(gl.FRAGMENT_SHADER, fragmentSource));
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(program));
        gl.useProgram(program);
        buffer = gl.createBuffer();
        if (!buffer) throw new Error('Buffer unavailable');
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 1,-1, -1,1, 1,1]), gl.STATIC_DRAW);
        const position = gl.getAttribLocation(program, 'position');
        gl.enableVertexAttribArray(position);
        gl.vertexAttribPointer(position, 2, gl.FLOAT, false, 0, 0);
        locations = {
          resolution: gl.getUniformLocation(program, 'u_resolution'),
          time: gl.getUniformLocation(program, 'u_time')
        };
        gl.uniform1f(gl.getUniformLocation(program, 'u_grain'), Number(this.dataset.grain));
        gl.uniform3fv(gl.getUniformLocation(program, 'u_bg'), new Float32Array(rgb(this.dataset.bg)));
        gl.uniform3fv(gl.getUniformLocation(program, 'u_colors[0]'), new Float32Array(this.dataset.colors.split(',').flatMap(rgb)));
        const resize = () => {
          const dpr = Math.min(window.devicePixelRatio || 1, 2);
          const width = Math.max(1, Math.round(this.clientWidth * dpr));
          const height = Math.max(1, Math.round(this.clientHeight * dpr));
          if (canvas.width !== width || canvas.height !== height) {
            canvas.width = width;
            canvas.height = height;
            gl.viewport(0, 0, width, height);
          }
          draw();
        };
        ro = new ResizeObserver(resize);
        ro.observe(this);
        io = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); });
        io.observe(this);
        document.addEventListener('visibilitychange', sync);
        motion.addEventListener('change', sync);
        canvas.addEventListener('webglcontextlost', onLost);
        canvas.addEventListener('webglcontextrestored', onRestored);
        resize();
        canvas.style.opacity = '1';
        sync();
      } catch (error) {
        canvas.style.opacity = '0';
        this.dispose();
        console.warn('Velaris: static background enabled.', error);
      }
    }
    initializeVideo(video) {
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      const sync = () => {
        if (visible && !document.hidden && !motion.matches) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      };
      video.muted = true;
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
        sync();
      });
      observer.observe(this);
      document.addEventListener('visibilitychange', sync);
      motion.addEventListener('change', sync);
      this.cleanup = () => {
        video.pause();
        observer.disconnect();
        document.removeEventListener('visibilitychange', sync);
        motion.removeEventListener('change', sync);
      };
    }
    dispose() { if (this.cleanup) { this.cleanup(); this.cleanup = null; } }
    disconnectedCallback() { cancelAnimationFrame(this.startFrame); this.dispose(); }
  }
  customElements.define('velaris-gradient', VelarisGradient);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-background-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('green-video-hero')) {
    customElements.define('green-video-hero', class extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        if (!video || !button) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const update = () => { button.textContent = video.paused ? button.dataset.play : button.dataset.pause; };
        video.addEventListener('play', update, options);
        video.addEventListener('pause', update, options);
        button.addEventListener('click', () => {
          if (video.paused) video.play().catch(update);
          else video.pause();
        }, options);
        button.hidden = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.motion.addEventListener('change', () => { if (this.motion.matches) video.pause(); }, options);
        if (!this.motion.matches) video.play().catch(update);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.querySelector('video')?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
